<template>
  <div>
    <!-- v-if="active_struct_mode.state !== 'link' ? process_detail_slot = 'content-right-bottom' : process_detail_slot = 'content-center-bottom-right'" -->
    <!-- is legit to set variable in v-if??? -^ -->

    <!-- IFC IMPORT DIALOG -->
    <StandardDialog v-if="$store.state.View.show_ifc_import_dialog" width="400px" height="150px" border_radius="10px"
      padding="6px" @click-outside="setValue({ key: 'show_ifc_import_dialog', value: false })">
      <template #content>
        <div style="display: flex; align-items: center; justify-content: space-between">
          <div><TText value="Import Settings" size="16" /></div>
          <v-btn icon color="white" @click="setValue({ key: 'show_ifc_import_dialog', value: false })">
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
        <div style="display: flex; align-items: center;">
          <DropDownOutlinedFlat label="Import Strategy" :options="getImportStrategies" :value="selected_import_strategy"
            :width="200" background_color="grey darken-4" foreground_color="white"
            @change="selected_import_strategy.value = $event" />
          <v-btn class="ml-3" @click="$refs.uploadIFC.click()">
            <TText value="Upload IFC" />
          </v-btn>
        </div>
        <div style="font-size: 8pt; font-weight: 300; margin-top: 8px;">
          <TText value="Take note of the" />
          <a href="https://knowledge.takting.com/category/takting-dokumentation/articles/94" target="_blank"
            title="IFC Import Guideline"><TText value="IFC Import Guideline" /></a>
        </div>
        <input v-show="false" ref="uploadIFC" type="file" accept=".ifc" @change="
          importing_ifc.ifc_size = $refs.uploadIFC.files[0].size / 1000000,
          ifc_upload_done = false,
          importing_ifc.importing = true,
          importIFCNew({
            project_id: project_id,
            ifc: $refs.uploadIFC.files[0],
            import_strategy: selected_import_strategy
          })
            .then(() => {
              ifc_upload_done = true;
            })
            .catch(err => {
              $refs.uploadIFC.value = '';
              importing_ifc.importing = false;
              setValue({ key: 'show_ifc_import_dialog', value: false });
              ifc_upload_done = false;
            })" />
      </template>
    </StandardDialog>

    <!-- Filter Management Dialog -->
    <StandardDialog v-if="$store.state.View.show_ifc_filter_dialog" width="800px" height="400px" border_radius="10px"
      padding="6px" @click-outside="setValue({ key: 'show_ifc_filter_dialog', value: false })">
      <template #content>
        <div style="display: flex; align-items: center; justify-content: space-between">
          <div class="basic-flex-row" style="justify-content: flex-start;">
            <TText value="Filter Management:" size="16" />
            <TText class="ml-1" :value="filter_management.type" size="16" />
          </div>
          <v-btn icon color="white" @click="setValue({ key: 'show_ifc_filter_dialog', value: false })">
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
        
        <!-- TABS -->

        <RadioButtonTextGroup
          :id="`projectstructure-filter-management`"
          :elements="[
            { text: 'MY.filters', value: 'custom', },
            { text: 'COMPANY.filters', value: 'business', disabled: true},
            { text: 'PROJECT.filters', value: 'project'},
            { text: 'STORE.filter', value: 'store', },
          ]"
          :selected="filter_management.tab"
          @buttonClicked="filter_management.tab=$event"
        />

        <!-- CONTENT -->

        <div v-if="['custom', 'business', 'project'].includes(filter_management.tab)">
          <!-- SEARCH -->

          <TSearchField
            height="30px"
            border_color="rgb(41,41,41)"
            :value="filter_management.search"
            @input="filter_management.search = $event.target.value"
            @cancel="filter_management.search = ''"
            />
  
          <!-- FILTERS -->

          <div 
            v-for="filter in structure_filters"
            :key="`structurefilter-${filter.id}`"
            class="basic-flex-row"
          >
            <TText :text="filter.name" />
            <!-- BUTTONS -->
            <div class="basic-flex-row" style="justify-content: flex-end; width: 10%;">
              <TTooltip value="Apply Filter">
                <ButtonOutlined
                  class="ml-1"
                  height="24"
                  width="24"
                  icon="filter"
                  @buttonClicked="applyFilter(filter.settings)"
                />
              </TTooltip>
              <TTooltip value="Delete Filter">
                <ButtonOutlined
                  class="ml-1"
                  height="24"
                  width="24"
                  icon="bin-delete"
                  @buttonClicked="deleteUObject({
                    url: [
                      { structurefilters: filter.id }
                    ],
                  })"
                />
              </TTooltip>
            </div>
          </div>

        </div>

        <!-- STORE -->
        <div v-if="filter_management.tab === 'store'">
          <TText value="Store current filter" size="14" />
          <div class="basic-flex-column mt-2">
            <DisableableInputField label="Name" :value="filter_management.new_filter.name" background_color="rgba(39, 39, 39, 0.7)" @change="filter_management.new_filter.name = $event" />
            <div class="basic-flex-row mt-2" style="justify-content: flex-start;">
              <RadialCheckbox
                foreground_color="white"
                shadow="black"
                @click.native.prevent.stop="filter_management.new_filter.project ? filter_management.new_filter.project = null :  filter_management.new_filter.project = project_id;"
                :is_checked="filter_management.new_filter.project === project_id"
              />
              <TText value="Project specific filter" />
            </div>
          </div>
          <ButtonOutlined class="mt-2" height="32" width="128" text="Save" @buttonClicked="saveFilter()" />
        </div>


      </template>
    </StandardDialog>

    <!-- IFC UPLOAD DIALOG -->
    <v-dialog :value="importing_ifc.importing" persistent max-width="500">
      <v-card class="pa-2" height="200" width="500"
        style="display: flex; flex-direction: column; justify-content: center; align-items: center">
        <template v-if="!ifc_upload_done">
          <TText value="Upload IFC..." size="24" font_weight="400" />
          <template>
            <TProgressBar v-if="importing_ifc.importing" height="30px" width="400px"
              :value="$store.state.ProjectStructure.ifc_upload_percentage" class="ma-3" />
            <div>
              {{ ($store.state.ProjectStructure.ifc_upload_loaded / 1000000).toFixed(2) }} MB / {{
                ($store.state.ProjectStructure.ifc_upload_total / 1000000).toFixed(2) }} MB
            </div>
            <!-- :ifc_size="importing_ifc.ifc_size" -->
            <v-progress-circular indeterminate />
          </template>
        </template>
        <template v-else>
          <div style="display: flex; flex-direction: column; padding: 4px; ">
            <TText value="Upload Done..." size="24" font_weight="400" />
            <div style="display:flex; flex-direction: column;">
              <TText value="The IFC file was uploaded." />
              <TText value="Based on the filesize the import process will take about {time} minutes." :value_props="{time: Math.ceil(($store.state.ProjectStructure.ifc_upload_total / 1000000 / 100) * 2)}"/>
              <TText value="You will receive an email as soon as the import is finished." />
              <TText value="Please reload the page then." />
            </div>
          </div>
          <v-btn class="mt-2" @click="
            $refs.uploadIFC.value = '';
          importing_ifc.importing = false;
          show_ifc_import_dialog = false;
          ifc_upload_done = false;
          ">
            <TText value="close" />
          </v-btn>
        </template>

      </v-card>
    </v-dialog>

    
    <!-- IFC WRAPPER/ELEMENT CREATE DIALOG -->
    <StandardDialog v-if="project_structure_create_dialog.show" width="700px" height="710px"  border_radius="10px"
      padding="6px" @click-outside="setValue({ key: 'project_structure_create_dialog', value: { show: false, object: {} }}); resetNewSpatialObject()">
      <template #content>
        <div class="pa-1 basic-flex-col">
          <div style="display: flex; align-items: center; justify-content: space-between">
          <div><TText value="Add spatial object to {type} {name}" :value_props="{type: $store.state.Ultra.ifc_name_by_type[project_structure_create_dialog.object.type], name: project_structure_create_dialog.object.name}" size="16" font_weight="400" /></div>
          <v-btn icon color="white" @click="setValue({ key: 'project_structure_create_dialog', value: { show: false, object: {} } }); resetNewSpatialObject()">
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
          
          <RadioButtonTextGroup
            id="project-structure-create-tabs"
            :elements="new_spatial_object_available_types"
            :selected="new_spatial_object.type"
            @buttonClicked="new_spatial_object.type=$event"
          />
  
          <TText value="Attributes" size="14" class="mt-2" />
          <div class="basic-flex-col" style="grid-gap:4px;">
            <DisableableInputField label="Name" :value="new_spatial_object.name" background_color="rgba(39, 39, 39, 0.7)" @change="new_spatial_object.name = $event" />
            <DisableableInputField label="Description" :value="new_spatial_object.description" background_color="rgba(39, 39, 39, 0.7)" @change="new_spatial_object.description = $event" />
            <DropDownOutlinedFlat v-if="new_spatial_object.type === 'elements'" label="IFC.type" :options="getIfcElementTypes" :value="new_spatial_object.ifc_type" background_color="rgba(39, 39, 39, 0.7)" @change="new_spatial_object.ifc_type = $event" style="width: 100%;" />
          </div>
  
          <TText value="Quantity" size="14" class="mt-2" />
          <div class="basic-flex-col" style="grid-gap:4px;">
            <DisableableInputField label="Count" :value="new_spatial_object.count" background_color="rgba(39, 39, 39, 0.7)" @change="new_spatial_object.count = $event" input_type="number" />
          </div>
          
          <div v-if="new_spatial_object.type === 'elements'" class="mt-2">
            <TText value="Geometry" size="14" />
            <div class="detail_list_view">
              <div v-for=" (value)  in  $store.state.Ultra.ifc_geometry_values " :key="value.prop">
                <DisableableInputField :label="value.text" :value="new_spatial_object[value.prop]" background_color="rgba(39, 39, 39, 0.7)" @change="new_spatial_object[value.prop] = parseFloat($event)" input_type="number" />
              </div>
            </div>
          </div>

          <div class="basic-flex-row mt-4" style="justify-content: flex-end; grid-gap:4px;" >
            <ButtonOutlined class="pointer_all" height="32" width="128" text="Cancel" @buttonClicked="setValue({ key: 'project_structure_create_dialog', value: { show: false, object: {} } }); resetNewSpatialObject()" />
            <ButtonOutlined class="pointer_all" height="32" width="128" text="Create" @buttonClicked="createIFCObject()" />
          </div>


        </div>
      </template>
    </StandardDialog>

    <!-- THREE CANVAS IN BACKGROUND-->
    <div 
      id="project-structure-frame-background" 
      class="project-structure-frame-background">
      <canvas id="three-canvas" class="canvas"></canvas>
    </div>

    <!-- REZIZABLE FRAME -->
    <ProjectStructureFrame>
      <!-- LEFT-TOP: Spatial Filter --->
      <template #content-left-top>
        <ProjectStructureTreeContainer :header="true">
          <template #header>
            <FilterHeader type="spatial" title="SPATIAL FILTER" @openFilterManagement="setValue({ key: 'show_ifc_filter_dialog', value: true }); filter_management.type = 'spatial';" />
          </template>
          <template #body>
            <ProjectStructureFilter 
              :filter_object="filter_object_spatial" 
              nested_index="" 
              tree_type="spatial"
              :depth="0"
              @changeLineComplete="triggerFilterCall('spatial')"
              @changeOperator="triggerFilterCall('spatial')"
              />
          </template>
        </ProjectStructureTreeContainer>
      </template>
      <!-- LEFT-CENTER: Spatial Tree -->
      <template #content-left-center>
        <ProjectStructureTreeContainer>

          <!-- Left Header Filter-->
          <template #header>
            <!-- now in tree component -->
            <!-- <div class="tree-header-bar">
              <ProjectStructureToggleContent icon="horizontal-dots">
                <div class="toggle_items"
                  v-for="(setting, index) in Object.keys($store.state.ProjectStructure.tree_settings_wrapper.spatial_tree)"
                  :key="index">
                  <RadialCheckbox foreground_color="white"
                    :is_checked="$store.state.ProjectStructure.tree_settings_wrapper.spatial_tree[setting]"
                    @setActive="updateSetting({ type: 'wrapper', tree: 'spatial_tree', setting: setting, value: !$store.state.ProjectStructure.tree_settings_wrapper.spatial_tree[setting] })" />
                  <TIcon :name="$store.state.Ultra.icon_by_type[setting]" />
                  {{ setting }}
                </div>
              </ProjectStructureToggleContent>
              <SearchBar underscored min_height="auto" @search="search = $event" />
            </div> -->

          </template>
          <!-- End Left Header Filter-->

          <!-- Left IFC Tree Content -->
          <template #body>
            <ProjectStructureTree 
              tree_type="spatial" 
              tree_name="spatial_tree" 
              tree_title="SPATIAL TREE"
              :active_spatial_element="active_tree_element_spatial"
              :object="project" 
              :depth="1"
              :targets="['elements']"
              @clickHeader="active_tree_element_spatial = active_tree_element_spatial_id_string === `${$event.type}#${$event.id}` ? false : $event"
              >
            </ProjectStructureTree>
          </template>
          <!-- End Left IFC Tree Content -->

        </ProjectStructureTreeContainer>
      </template>

      <!-- LEFT-BOTTOM: Spatial Details -->
      <template #content-left-bottom="{child, resize_id}">
        <ProjectStructureDetails :tabs="getTabs('spatial', active_tree_element_spatial)">

          <!-- Details Title Header -->
          <template #details_title_left v-if="active_tree_element_spatial">
            <TIcon class="detail_header_left" :name="$store.state.Ultra.icon_by_type[active_tree_element_spatial.type]" />
          </template>
          <template #details_title_center_top v-if="active_tree_element_spatial">
            <TText style="justify-content: center;" color="white" size="14" max_lines="1" :text="active_tree_element_spatial.name" />
          </template>
          <template #details_title_center_top v-else>
            <TText color="white" class="mt-1" style="justify-content: center;" size="14" value="No Spatial Element selected" />
          </template>
          <template #details_title_center_bottom v-if="active_tree_element_spatial">
            <TText color="#FFFFFF80" size="10" text="Type:" />
            <TText color="white" size="10" :text="active_tree_element_spatial.ifc_type" />

            <TText color="#FFFFFF80" size="10" text="Id:" />
            <TText color="white" size="10" :text="active_tree_element_spatial.id" />
          </template>
          <template #details_title_right v-if="active_tree_element_spatial">
            <div class="basic-flex-column">
              <div class="basic-flex-row mt-2">
                <!-- selection -->
                <TTooltip :value="checkSelectedResult('selected_elements', active_tree_element_spatial) === 'complete' ? 'Remove from selection' : 'Add to Selection' ">
                  <TIcon size="16"
                    style="cursor: pointer;"
                    :name="checkSelectedResult('selected_elements', active_tree_element_spatial) === 'complete' ? 'checkbox-radial-filled' : checkSelectedResult('selected_elements', active_tree_element_spatial) === 'part'?'radial-checkbox-dashed':'checkbox-radial-empty'"
                      @click.native.prevent.stop="setCollection('selected_elements', active_tree_element_spatial)" 
                  />
                </TTooltip>

                <!-- visible -->
                <TTooltip value="Set 3D">
                  <TIcon size="16" 
                      name="visiblity-single" style="cursor: pointer;"
                      @click.native.prevent.stop="showSingleElementOrWrapper(active_tree_element_spatial)" 
                  />
                </TTooltip>
                <!-- visible -->
                <TTooltip :value="checkSelectedResult('visible_elements', active_tree_element_spatial) === 'complete' ? 'Remove from 3D' : 'Add to 3D' ">
                  <TIcon size="16" style="cursor: pointer;"
                      :name="checkSelectedResult('visible_elements', active_tree_element_spatial) === 'complete' ? 'visibility-on' : checkSelectedResult('visible_elements', active_tree_element_spatial) === 'part'?'visiblity-half':'visibility-off'" 
                      @click.native.prevent.stop="setCollection('visible_elements', active_tree_element_spatial)" 
                  />
                </TTooltip>
              </div>
              <div class="basic-flex-row">
                <!-- POPUP -->
                <v-btn  icon @click.prevent.stop="spatial_details_popup = !spatial_details_popup" v-if="active_tree_element_spatial.type !== 'projects'" >
                  <TIcon name="vertical-dots" />
                </v-btn>
                <TransitionAccordion>
                  <PopUpOverlay 
                    style="z-index: 20;"
                    :width="`60px`"
                    :margin="8"
                    :is_no_cancel="true"
                    :position_css="`right: 10px; transform: translate(0%, 100%); `" 
                    v-if="spatial_details_popup" @closeOverlay="spatial_details_popup = false" 
                  >
                    <template #body>
                      <ClickablePopUpIcon
                        icon="bin-delete"
                        color="var(--primary)"
                        description="delete"
                        @selected="deleteUObject({
                          url: [
                            { [active_tree_element_spatial.type]: active_tree_element_spatial.id }
                          ],
                          url_prefix: `/projects/${project_id}/projectstructure`
                        }); spatial_details_popup = false; active_tree_element_spatial = false; "
                      />
                    </template>
                  </PopUpOverlay>
                </TransitionAccordion>
                <TTooltip value="Close">
                  <TIcon style="cursor: pointer;" name="sign-close" @click.native="active_tree_element_spatial = false" />
                </TTooltip>
                <TTooltip :value="child.minimized ? 'Open Details' : 'Minimize Details'">
                  <TIcon style="cursor: pointer;" :name="child.minimized ? 'chevron-up' : 'chevron-down'" @click.native="resizeContainer(resize_id)" />
                </TTooltip>
              </div>
            </div>
          </template>

          <template #detail_breadcrumbs v-if="active_tree_element_spatial">
            <div
              v-for="(parent, index) in getObjectUrl(active_tree_element_spatial).path"
              :key="`path${parent.type}${parent.id}`"
              style="display:flex;align-items:center;"
            >
            <TTooltip :value="$store.state.Ultra[parent.type][parent.id].name ? $store.state.Ultra[parent.type][parent.id].name : parent.type">
              <TIcon size="18" :name="$store.state.Ultra.icon_by_type[parent.type]" style="cursor:pointer;" @click.native="active_tree_element_spatial = $store.state.Ultra[parent.type][parent.id]" />
            </TTooltip>
              <TIcon size="18" name="chevron-right" v-if="getObjectUrl(active_tree_element_spatial).path.length > 1 && getObjectUrl(active_tree_element_spatial).path.length - 1 !== index" />
            </div>
          </template>


          <template #default="{ tab_content }" v-if="active_tree_element_spatial">
            <div v-if="tab_content === 'details'">
              <!-- path -->
              <div class="tree_details">
      
                <div v-if="isObjectFullFetched(active_tree_element_spatial)">

                  <hr style="border-color:  #FFFFFF80;">
                  <div class="py-2">
                    <DisableableInputField label="Name"
                      :is_disabled="ui_mode !== 'edit' || active_tree_element_spatial.type === 'projects'"
                      :value="active_tree_element_spatial.name" background_color="rgba(39, 39, 39, 0.7)" @change="updateUObject({
                        url: [
                          { [active_tree_element_spatial.type]: active_tree_element_spatial.id }
                        ],
                        url_prefix: `/projects/${project_id}/projectstructure`,
                        update: {
                          name: $event,
                        }
                      })" />
                    <TTooltip value="Set to Filter (CTRL + click to add as new Filterline)">
                      <TIcon size="16" 
                          name="filter" style="cursor: pointer;"
                          @click.native.prevent.stop="takeoverFilter({ 
                              tree_type: 'spatial', 
                              filtertype: 'filter_attr', 
                              attributename: 'name', 
                              value: active_tree_element_spatial.name, 
                              event: $event 
                          })"
                      />
                    </TTooltip>
                    <!--   @click.native.prevent.stop="showSingleElementOrWrapper(active_tree_element_spatial)"  -->

                    <!-- Description (SEPARAT) -->
                    <DisableableInputField label="Description" v-if="active_tree_element_spatial.type !== 'projects'"
                      :is_disabled="ui_mode !== 'edit'"
                      :value="active_tree_element_spatial.description" background_color="rgba(39, 39, 39, 0.7)" @change="updateUObject({
                        url: [
                          { [active_tree_element_spatial.type]: active_tree_element_spatial.id }
                        ],
                        url_prefix: `/projects/${project_id}/projectstructure`,
                        update: {
                          description: $event,
                        }
                      })" />
                  </div>
                  <hr style="border-color:  #FFFFFF80;">
                  <!-- 
                  <div>description: {{ active_tree_element_spatial.description }}</div> -->
                  <div class="mt-4 mb-1 px-5" v-if="active_tree_element_spatial.type === 'elements'">
                    <TText text="Geometry" font_weight="400" />
                    <div class="detail_list_view">
                      <div v-for=" (value)  in  $store.state.Ultra.ifc_geometry_values " :key="value.prop">

                        <!-- <div v-if="(index % 4 == 0 || (index - 1) % 4 == 0) && index > 1" class="grid_space"></div> -->
                        <!-- value = { prop: "xy", text: "xy"} -->
                        <!-- <DisableableInputField :label="value.text"
                          :is_disabled="ui_mode !== 'edit'"
                          :value="active_tree_element_spatial[value.prop]" background_color="rgba(39, 39, 39, 0.7)"
                          @change="updateUObject({
                            url: [
                              { elements: active_tree_element_spatial.id }
                            ],
                            url_prefix: `/projects/${project_id}/projectstructure`,
                            update: {
                              [value.prop]: !isNaN(parseFloat($event)) ? parseFloat($event) : $event,
                            }
                          })" /> -->

                          <InputAndSourceField
                            :label="value.text"
                            :read_only="ui_mode !== 'edit'"
                            :val="active_tree_element_spatial[value.prop]"
                            :source_val="active_tree_element_spatial[`${value.prop}_source`]"
                            background_color="rgba(39, 39, 39, 0.7)"
                            :showTakeoverFilter="true"
                            @takeoverFilter="takeoverFilter({ 
                                tree_type: 'spatial', 
                                filtertype: 'filter_attr', 
                                attributename: value.prop, 
                                value: active_tree_element_spatial[value.prop], 
                                event: $event 
                            })"
                            @change="updateUObject({
                              url: [
                                { elements: active_tree_element_spatial.id }
                              ],
                              url_prefix: `/projects/${project_id}/projectstructure`,
                              update: {
                                [value.prop]: !isNaN(parseFloat($event)) ? parseFloat($event) : $event,
                              }
                            }); updateUDObject({
                              url: [
                                { elements: active_tree_element_spatial.id }
                              ],
                              url_prefix: `/projects/${project_id}/projectstructure`,
                              update: {
                                [`${value.prop}_source`]: `Set by User (${$store.state.Auth.current_user.first_name} ${$store.state.Auth.current_user.last_name})`
                              }
                            })"
                          />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else><TText value="loading..." /></div>
              </div>
            </div>

            <!-- props -->
            <div v-else-if="tab_content === 'props'">
              <template v-if="isObjectFullFetched(active_tree_element_spatial)">
                <ProjectStructureElementPropSet
                  v-for="prop_set in getUObjects({ type: 'propertysets', ids: active_tree_element_spatial.propertysets })"
                  :key="prop_set.id"
                  :prop_set="prop_set"
                  :showTakeoverFilter="true"
                  @takeoverFilter="takeoverFilter({ 
                      tree_type: 'spatial', 
                      filtertype: 'filter_prop', 
                      propsetname: prop_set.name, 
                      propname: $event.prop.name, 
                      value: $event.prop.value,
                      event: $event.evt
                  })"
                  @mapValue="updateUObject({
                    url: [
                      { elements: active_tree_element_spatial.id }
                    ],
                    url_prefix: `/projects/${project_id}/projectstructure`,
                    update: ['name', 'description'].includes($event.attribute) ?
                      {
                        [$event.attribute]: $event.prop.value,
                      }
                      :
                      {
                        [$event.attribute]: !isNaN(parseFloat($event.prop.value)) ? parseFloat($event.prop.value) : $event.prop.value,
                        [`${$event.attribute}_source`]: `${prop_set.name} ${$event.prop.name}`,
                      }
                  })
                    " />
              </template>
              <div v-else><TText value="loading..." /></div>
            </div>

            <!-- linked taktareas -->
            <div v-else-if="tab_content === 'taktareas'">
              <template v-if="isObjectFullFetched(active_tree_element_spatial)">
                <!-- now in tree component -->
                <!-- <div class="tree-header-bar">
                  <ProjectStructureToggleContent icon="horizontal-dots">
                    <div class="toggle_items"
                      v-for="(setting, index) in Object.keys($store.state.ProjectStructure.tree_settings_wrapper.element_taktareas)"
                      :key="index">
                      <RadialCheckbox foreground_color="white"
                        :is_checked="$store.state.ProjectStructure.tree_settings_wrapper.element_taktareas[setting]"
                        @setActive="updateSetting({ type: 'wrapper', tree: 'element_taktareas', setting: setting, value: !$store.state.ProjectStructure.tree_settings_wrapper.element_taktareas[setting] })" />
                      <TIcon :name="$store.state.Ultra.icon_by_type[setting]" />
                      {{ setting }}
                    </div>
                  </ProjectStructureToggleContent>
                  <SearchBar underscored min_height="auto" @search="search = $event" />
                </div> -->
                <ProjectStructureTree 
                  tree_type="process" 
                  tree_name="element_taktareas"
                  tree_title="LINKED AREAS"
                  :collection_object="getAllChildObjectIds({ parent: active_tree_element_spatial, tree_type: 'spatial', targets: ['taktareas'] })"
                  :object="project" 
                  :depth="1" 
                  :targets="['taktareas']"
                  @clickHeader="handleClickHeader('process', $event)"
                  >
                </ProjectStructureTree>
              </template>
              <div v-else><TText value="loading..." /></div>
            </div>

            <!-- linked steps -->
            <div v-else-if="tab_content === 'steps'">
              <template v-if="isObjectFullFetched(active_tree_element_spatial)">
                <!-- now in tree component -->
                <!-- <div class="tree-header-bar">
                  <ProjectStructureToggleContent icon="horizontal-dots">
                    <div class="toggle_items"
                      v-for="(setting, index) in Object.keys($store.state.ProjectStructure.tree_settings_wrapper.element_steps)"
                      :key="index">
                      <RadialCheckbox foreground_color="white"
                        :is_checked="$store.state.ProjectStructure.tree_settings_wrapper.element_steps[setting]"
                        @setActive="updateSetting({ type: 'wrapper', tree: 'element_steps', setting: setting, value: !$store.state.ProjectStructure.tree_settings_wrapper.element_steps[setting] })" />
                      <TIcon :name="$store.state.Ultra.icon_by_type[setting]" />
                      {{ setting }}
                    </div>
                  </ProjectStructureToggleContent>
                  <SearchBar underscored min_height="auto" @search="search = $event" />
                </div> -->
                <ProjectStructureTree 
                  tree_type="process" 
                  tree_name="element_steps"
                  tree_title="LINKED STEPS"
                  :collection_object="getAllChildObjectIds({ parent: active_tree_element_spatial, tree_type: 'spatial', targets: ['tworksteps'] })"
                  :object="project" 
                  :depth="1" 
                  :targets="['tworksteps']"
                  @clickHeader="handleClickHeader('process', $event)"
                  >
                </ProjectStructureTree>
              </template>
              <div v-else><TText value="loading..." /></div>
            </div>

          </template>
          <template #default v-else>
          </template>
        </ProjectStructureDetails>
      </template>

      <!-- CENTER-TOP: Buttons -->
      <template #content-center-top>
        <div style="position: relative; height: 100%;">
          <!-- mode switch button -->
        <div style="position: absolute; left: 50%; transform: translateX(-50%);">
          <DropDownOutlinedFlat 
            :options="$store.state.ProjectStructure.ui_mode_options"
            :value="ui_mode" 
            :width="130" 
            style="pointer-events: all; user-select: none;" 
            label="UI.mode"
            foreground_color="#fff" 
            background_color="#757575" 
            :is_disabled="false" 
            @change="setUiMode($event)" />
        </div>
        <!-- side buttons -->
        <div class="basic-flex-col" style="grid-gap: 2px;">
          <div
            class="d-flex"
            v-for="(side_button, index) in side_buttons" :key="`sidebar_button#${index}`"
          >
          <TTooltip :value="side_button.text">
            <ButtonOutlined
              :class="`pointer_all mr-1 ${side_button.clicked === true ? 'grey' : 'side-button'}`"
              height="32" 
              width="32"
              :icon="side_button.icon"            
              @buttonClicked="!is_presentation_mode_buttons({type: 'presentation-mode'}) ? handleSideButtons(side_button.type) : ''"
            />
          </TTooltip>
          <TransitionFade >
          <div class="d-flex" v-if="is_presentation_mode_buttons(side_button)" v-click-outside="togglePresentationMode">
            <div v-for="(icon, index_2) in side_button.icons" :key="`sidebar_button_presentation#${index_2}`">
              <TTooltip :value="getPresentationModeButtonTooltip(index_2 + 1)">
                  <ButtonOutlined
                    v-if="is_presentation_mode_buttons(side_button)"
                    :class="`pointer_all mr-1 ${side_button.selected_button === (index_2 + 2) ? 'grey' : 'side-button'}`"
                    height="32" 
                    width="32"
                    :icon="icon"            
                    @buttonClicked="activateModeByIndex(index_2 + 1)"
                  />
                </TTooltip>
              </div>
            </div>
          </TransitionFade>
          <div 
            class="d-flex pointer_all"
            style="user-select: none; align-items: center justify-content: center;"
            v-if="side_buttons[3].clicked && side_button.type === 'sections-horizontal'"
            >
            <DisableableInputField
              width="100px" 
              label="Height"
              :value="clipping_plane_hor.constant" 
              foreground_color="#fff" 
              background_color="#757575" 
              input_type="number"
              input_mode="decimal"
              :is_disabled="false"
              unit="m"
              @change="setClippingPlaneHor($event)"
              />
            <SectionSettings 
              class="ml-1"
              :show_clip_caps="show_clip_caps"
              :flip_normals="flip_normals"
              @changeShowClipCaps="show_clip_caps = $event"
              @changeFlipNormals="flip_normals = $event"
            />
          </div>

          <DisableableInputField
          v-if="side_buttons[4].clicked && side_button.type === 'sections-vertical-x'"
            style="pointer-events: all; user-select: none;"
            width="100px" 
            label="Height"
            :value="clipping_plane_ver_x.constant" 
            foreground_color="#fff" 
            background_color="#757575" 
            input_type="number"
            input_mode="decimal"
            :is_disabled="false"
            unit="m"
            @change="setClippingPlaneVertX($event)"
            />
          <DisableableInputField
          v-if="side_buttons[5].clicked && side_button.type === 'sections-vertical-y'"
            style="pointer-events: all; user-select: none;"
            width="100px" 
            label="Height"
            :value="clipping_plane_ver_y.constant" 
            foreground_color="#fff" 
            background_color="#757575" 
            input_type="number"
            input_mode="decimal"
            :is_disabled="false"
            unit="m"
            @change="setClippingPlaneVertY($event)"
            />
          </div>
        </div>
        <!-- gizmo -->
        <div class="gizmo-container">
          <div class="d-flex" style="justify-content: center;">
            <div class="gizmo-btn-direction isometric" @click="gizmoChangeDirection('back-left')"></div>
            <div class="gizmo-btn-direction" @click="gizmoChangeDirection('back')"><TText value="back" /></div>
            <div class="gizmo-btn-direction isometric" @click="gizmoChangeDirection('back-right')"></div>
          </div>
          <div class="d-flex" style="justify-content: center;">
            <div class="gizmo-btn-direction" @click="gizmoChangeDirection('left')"><TText value="left" /></div>
            <div class="gizmo-btn-direction" @click="gizmoChangeDirection('top')"><TText value="top" /></div>
            <div class="gizmo-btn-direction" @click="gizmoChangeDirection('right')"><TText value="right" /></div>
          </div>
          <div class="d-flex" style="justify-content: center;">
            <div class="gizmo-btn-direction isometric" @click="gizmoChangeDirection('front-left')"></div>
            <div class="gizmo-btn-direction" @click="gizmoChangeDirection('front')"><TText value="front" /></div>
            <div class="gizmo-btn-direction isometric" @click="gizmoChangeDirection('front-right')"></div>
          </div>
          <div class="d-flex" style="justify-content: center;">
            <div class="gizmo-btn-camera" @click="gizmoChangeCamera('3D')" :style="camera_type === '3D'?'background-color: rgba(200,200,200,0.5)':''"><TText value="3D" /></div>
            <div class="gizmo-btn-camera" @click="gizmoChangeCamera('Ortho')" :style="camera_type === 'Ortho'?'background-color: rgba(200,200,200,0.5)':''"><TText value="Ortho" /></div>
          </div>
          <div class="gizmo-btn-camera" @click="controls.enableRotate = !controls.enableRotate" :style="!controls.enableRotate?'background-color: rgba(200,200,200,0.5)':''"><TText value="LOCK" /></div>
        </div>
        <div class="drawing-toolbar" v-if="is_edit_geom">
          <ProjectStructureTreeContainer header_only="true">
            <template #header>
              <div style="width: 100%">
                <div class="d-flex" style="width: 100%; height: 100%; align-items: center; justify-content: space-between;">
                  <!-- HEIGHT -->
                  <DisableableInputField label="Height"
                    v-if="edit_geom.extrude_value"
                    width="64px"
                    :value="edit_geom.extrude_value" 
                    disabled="true"
                    background_color="rgba(39, 39, 39, 0.7)" 
                    :is_disabled="edit_geom_point_index !== -1"
                    style="height: 36px"
                    @keyup.native.prevent.stop
                    @change="edit_geom.extrude_value = parseFloat($event), updateMeshGeometry(edit_geom_mesh, edit_geom)" />
                    <!-- Z-LEVEL -->
                    <DisableableInputField label="Z-Level"
                      v-if="edit_geom.offset"
                      width="64px"
                      :value="edit_geom.offset[1]" 
                      background_color="rgba(39, 39, 39, 0.7)" 
                      :is_disabled="edit_geom_point_index !== -1"
                      style="height: 36px"
                      @keyup.native.prevent.stop
                      @change="edit_geom.offset[1] = parseFloat($event), edit_geom_mesh.position.y = parseFloat($event), refreshHandles()" />
                      <div class="d-flex" style="align-items: center;">
                        <RadialCheckbox 
                          foreground_color="white"
                          :is_checked="use_magnetic_points"
                          style="zoom: 0.8"
                          @setActive="use_magnetic_points = !use_magnetic_points" 
                        />
                        <TText value="magnetic points"/>
                      </div>
                                      <!-- instructions -->
                <div>
                  <!-- no point editing -->
                  <template v-if="edit_geom_point_index === -1">
                    <TText 
                      :size="10"
                      :font_weight="100"
                      style="font-style: italic;"
                      value="click red handle: edit point"
                    />
                    <TText 
                      :size="10"
                      :font_weight="100"
                      style="font-style: italic;"
                      value="click yellow handle: insert point"
                    />
                  </template>
                  <!-- point editing -->
                  <template v-else>
                    <!-- create mode -->
                    <template v-if="create_geom_mode">
                      <TText 
                        :size="10"
                        :font_weight="100"
                        style="font-style: italic;"
                        value="click: set point"
                      />
                      <TText 
                        :size="10"
                        :font_weight="100"
                        style="font-style: italic;"
                        v-if="edit_geom.points_x.length > 3"
                        value="esc: end create"
                      />
                      <TText 
                        :size="10"
                        :font_weight="100"
                        style="font-style: italic;"
                        v-else
                        value="esc: cancel create mode (< 3 points)"
                      />
                      <TText 
                        :size="10"
                        :font_weight="100"
                        style="font-style: italic;"
                        v-if="edit_geom.points_x.length > 1"
                        value="backspace: revert last point"
                      />
                      <TText 
                        :size="10"
                        :font_weight="100"
                        style="font-style: italic;"
                        v-if="edit_geom.points_x.length === 1"
                        value="backspace: cancel create mode (< 3 points)"
                      />
                    </template>
                    <!-- editing mode -->
                    <template v-else>
                      <TText 
                        :size="10"
                        :font_weight="100"
                        style="font-style: italic;"
                        value="click: set point"
                      />
                      <TText 
                        :size="10"
                        :font_weight="100"
                        style="font-style: italic;"
                        value="esc: cancel point edit"
                      />
                      <TText 
                        v-if="edit_geom.points_x.length > 3"
                        :size="10"
                        :font_weight="100"
                        style="font-style: italic;"
                        value="backspace: delete point"
                      />
                      <TText 
                        v-else
                        :size="10"
                        :font_weight="100"
                        style="font-style: italic;"
                        value="backspace: cancel point edit (min 3 points)"
                      />
                    </template>
                  </template>
                </div>
                      <div class="d-flex">
                        <TTooltip value="End editing and update geometry">
                          <TIcon  
                            class="cursor-pointer"
                            name="check-circle"
                            :is_disabled="edit_geom_point_index !== -1"
                            color="white"
                            @click.native.prevent.stop="
                              edit_geom_point_index === -1?
                              endEditGeometry(
                                edit_geom.points_x.length > 2?true:false, 
                                false, 
                                edit_geometry_object.url
                              ):''"
                          />
                        </TTooltip>
                        <TTooltip value="Cancel editing">
                          <TIcon  
                            class="cursor-pointer"
                            name="close-circle" 
                            :is_disabled="edit_geom_point_index !== -1"
                            color="white"
                            @click.native.prevent.stop="edit_geom_point_index === -1?endEditGeometry(false):''"
                          />
                        </TTooltip>
                        <TTooltip value="Delete Geometry">
                          <TIcon  
                            class="cursor-pointer"
                            name="bin-delete" 
                            :is_disabled="edit_geom_point_index !== -1"
                            color="white"
                            @click.native.prevent.stop="
                            edit_geom_point_index === -1?
                              (
                              edit_geom = { 
                                  type: 'ExtrudedShape',
                                  extrude_value: 10,
                                  points_x: [],
                                  points_y: [],
                                  points_z: [],
                                  offset: [0,0,0],
                                  normal: [0,0,1],
                                  max_points: false,
                                  min_points: 3,
                                  path_length: 0,
                                },
                              endEditGeometry(true, false, edit_geometry_object.url).then(() => {
                                edit_geometry_object.type === 'taktareashapes'?
                                removeUnstagedShapeMeshes(edit_geometry_object.id)
                                :''
                              })
                              ):''
                            "
                          />
                        </TTooltip>
                      </div>
                </div>
              </div>
            </template>
          </ProjectStructureTreeContainer>
        </div>
        <div class="selection-toolbar" v-else-if="ctrl_key_down" oncontextmenu="return false;">
          <ProjectStructureTreeContainer header_only="true">
            <template #header>
              <div class="d-flex" style="align-items: center;">
                <div style="display: flex; border: 1px solid white; border-radius: 5px; height: 30px">
                  <v-btn 
                    small 
                    :color="selection_mode === 'intersects'?'grey':''"
                    @mouseup="selection_mode = 'intersects'"  
                    >
                    <TText value="intersects" />
                  </v-btn>
                  <v-btn 
                    small 
                    :color="selection_mode === 'contains'?'grey':''"
                    @mouseup="selection_mode = 'contains'"  
                    >
                    <TText value="contains" />
                  </v-btn> 
                </div>
                <DisableableInputField 
                    class="ml-2"
                    label="Threshold"
                    v-if="selection_mode === 'contains'"
                    width="64px"
                    :value="contains_threshold * 100" 
                    disabled="true"
                    background_color="rgba(39, 39, 39, 0.7)" 
                    :is_disabled="selection_mode !== 'contains'"
                    style="height: 36px"
                    @keyup.native.prevent.stop
                    @change="contains_threshold = $event / 100" />
              </div>
              </template>
          </ProjectStructureTreeContainer>
        </div>
      </div>
      </template>

      <!-- CENTER-BOTTOM: Selection--->
      <template #content-center-bottom>
        <ProjectStructureTreeContainer
          body2="true" 
          body_center="true" 
          :header="true"
          :header_only="ui_mode === '4d'"
          >
          <template #header>
            <template v-if="ui_mode === '4d'">
              <div class="basic-flex-row">
                <div class="basic-flex-row" style="width: 10%; justify-content:flex-start;">
                  <TText value="4D Simulation" />
                </div>
                <div v-if="hasCalendar(project_id)" class="basic-flex-col" style="align-items: center;grid-gap: 2px;">
                  <TText value="TAKT" />
                  <div class="basic-flex-row" style="width:80%;justify-content:center;">
                    <ButtonOutlined
                      height="42"
                      width="24"
                      icon="chevron-left"
                      @buttonClicked="set4DSimulation(current_4d_takt - 1)"
                    />
                    <DisableableInputField 
                      width="64px"
                      :value="current_4d_takt + 1" 
                      background_color="rgba(39, 39, 39, 0.7)" 
                      @change="set4DSimulation(parseInt($event))" 
                    />
                    <ButtonOutlined
                      height="42"
                      width="24"
                      icon="chevron-right"
                      @buttonClicked="set4DSimulation(current_4d_takt + 1)"
                    />
                  </div>
                  <TText :text="takt_date_for_4d" />
                </div>
                <div v-else class="basic-flex-col" style="align-items: center;grid-gap: 2px;">
                  <TText value="The 4D simulation requires a calendar" />
                </div>
                <div v-if="hasCalendar(project_id)" class="basic-flex-row" style="width: 10%; justify-content:flex-end;">
                  <RadialCheckbox 
                    foreground_color="white"
                    :is_checked="cumulative_4d"
                    @setActive="cumulative_4d = !cumulative_4d; set4DSimulation(current_4d_takt)" 
                  />
                  <TText value="cumulative" />
                </div>
              </div>
            </template>
            <template v-if="ui_mode === 'link'"> 
              <!-- header center bottom -->
              <div style="display: flex; border: 1px solid white; border-radius: 5px">
                <v-btn 
                  small 
                  color="grey"
                  >
                  <TText value="Elements" />
                </v-btn>
              </div>
              <v-spacer></v-spacer>
              <TText :text="selected_elements.elements.length" />
              <v-spacer></v-spacer>
              <!-- <div>Selection</div> -->
              <TText v-if="link_feedback.active" :value="link_feedback.text" />
              <div v-else>
                <v-btn
                  small
                  @click="handleLinkObjects('link')"
                  >
                  <TText value="link" />
                </v-btn>
                <!-- <v-btn
                  class="ml-1 mr-1"
                  small
                  @click="handleLinkObjects('auto')"
                  >
                  <TText :value="link_btn_text" />
                </v-btn> -->
                <v-btn
                  class="ml-1"
                  small
                  @click="handleLinkObjects('unlink')"
                  >
                  <TText value="unlink" />
                </v-btn>
              </div>

              <v-spacer></v-spacer>
                <TText :text="selected_steps_count" />
              <v-spacer></v-spacer>
              <div style="display: flex; border: 1px solid white; border-radius: 5px">
                <v-btn 
                  small 
                  :color="process_selection_type === 'taktareas'?'grey':''"
                  @click="process_selection_type = 'taktareas'"  
                  >
                  <TText value="Areas" />
                </v-btn>
                <v-btn 
                  small 
                  :color="process_selection_type === 'steps'?'grey':''"
                  @click="process_selection_type = 'steps'"  
                  >
                  <TText value="Steps" />
                </v-btn>   
              </div>
            </template> 
          </template>
          <template #body>
            <!-- spatial collection -->
            <template v-if="selected_elements.elements.length !== 0">
              <ProjectStructureTree 
                tree_type="spatial" 
                tree_name="spatial_collection"
                tree_title="SPATIAL SELECTION"
                :collection_object="selected_elements" 
                :object="project" 
                :depth="1"
                :targets="['elements']"
                @clickHeader="active_tree_element_spatial = active_tree_element_spatial_id_string === `${$event.type}#${$event.id}` ? false : $event"
                >
              </ProjectStructureTree>
            </template>
          </template>

          <!-- process selection -->
          <template #body2 v-if="has_selected_steps">
            <ProjectStructureTree 
              v-if="process_selection_type === 'steps'"
              tree_type="process" 
              tree_name="process_collection"
              tree_title="STEP SELECTION"
              :collection_object="$store.state.ProjectStructure.selected_steps" 
              :object="project" 
              :depth="1"
              :targets="['tworksteps']"
              @clickHeader="handleClickHeader('process', $event)">
            </ProjectStructureTree>
            <ProjectStructureTree 
              v-else
              tree_type="process" 
              tree_name="element_taktareas"
              tree_title="AREA SELECTION"
              :collection_object="{taktareas: getCollectionParents({collection_object: $store.state.ProjectStructure.selected_steps, target_types: ['taktareas']}).taktareas}"
              :object="project" 
              :depth="1" 
              :targets="['taktareas']"
              @clickHeader="handleClickHeader('process', $event)">
            </ProjectStructureTree>
          </template>
        </ProjectStructureTreeContainer>

      </template>
      <!-- RIGHT-Top: Process Filter --->
      <template #content-right-top>
        <ProjectStructureTreeContainer header="true">
          <template #header>
            <FilterHeader type="process" title="PROCESS FILTER" @openFilterManagement="setValue({ key: 'show_ifc_filter_dialog', value: true }); filter_management.type = 'process';" />
          </template>
          <template #body>
            <ProjectStructureFilter 
              :filter_object="filter_object_process" 
              nested_index="" 
              tree_type="process"
              :depth="0"
              @changeLineComplete="triggerFilterCall('process')"
              @changeOperator="triggerFilterCall('process')"
              />
          </template>
        </ProjectStructureTreeContainer>
      </template>
      <!-- RIGHT-CENTER: Process Tree --->
      <template  #content-right-center> <!-- dynamic slot name with #[slot_name_variable]-->
        <ProjectStructureTreeContainer>
          <template #header>
            <!-- now in tree component -->

            <!-- <div class="tree-header-bar">
                <ProjectStructureToggleContent icon="horizontal-dots">
                  <div class="toggle_items"
                    v-for="(setting, index) in Object.keys($store.state.ProjectStructure.tree_settings_wrapper.process_tree)"
                    :key="index">
                    <RadialCheckbox foreground_color="white"
                      :is_checked="$store.state.ProjectStructure.tree_settings_wrapper.process_tree[setting]"
                      @setActive="updateSetting({ type: 'wrapper', tree: 'process_tree', setting: setting, value: !$store.state.ProjectStructure.tree_settings_wrapper.process_tree[setting] })" />
                    <TIcon :name="$store.state.Ultra.icon_by_type[setting]" />
                    {{ setting }}
                  </div>
                </ProjectStructureToggleContent>
                <SearchBar underscored min_height="auto" @search="search = $event" />
              </div> -->

          </template>
          <template #body>
            <!-- v-for="child in tree_process.children" 
            :key="child.type + child.id"  -->
            <ProjectStructureTree 
              tree_type="process" 
              tree_name="process_tree" 
              tree_title="PROCESS TREE"
              :object="project" 
              :depth="1"
              :targets="['tworksteps']"
              :active_spatial_element="active_tree_element_spatial"
              :active_process_element="active_tree_element_process"
              @clickHeader="handleClickHeader('process', $event)"
              >
            </ProjectStructureTree>
            <!-- @clickHeader="active_tree_element_process = `${active_tree_element_process.type}${active_tree_element_process.id}` === `${$event.type}${$event.id}` ? false : $store.state.Ultra[$event.type][$event.id]" -->
          </template>
        </ProjectStructureTreeContainer>
      </template>

      <!-- RIGHT-BOTTOM: Process Details -->
      <template #content-right-bottom="{child, resize_id}"> <!-- dynamic slot name with #[slot_name_variable]-->
        <ProjectStructureDetails 
          :tabs="getTabs('process', active_tree_element_process)" 
          @checkBoxClick="processDetailsTabCheckBoxClick($event)">

          <!-- Details title header-->
          <template #details_title_left v-if="active_tree_element_process">
            <TIcon class="detail_header_left" :name="$store.state.Ultra.icon_by_type[active_tree_element_process.type]" />
          </template>
          <template #details_title_center_top v-if="active_tree_element_process">
            <TText v-if="active_tree_element_process.name" color="white" style="justify-content: center;" size="14" :text="active_tree_element_process.name" />
            <TText v-else color="white" style="justify-content: center;" size="14" :text="active_tree_element_process.token || 'Wagon'" />
          </template>
          <template #details_title_center_top v-else>
            <TText color="white" class="mt-1" style="justify-content: center;" size="14" value="No Process Element selected" />
          </template>
          <template #details_title_center_bottom v-if="active_tree_element_process">
            <TText color="#FFFFFF80" size="10" text="Type:" />
            <TText color="white" size="10" :text="active_tree_element_process.type" />

            <TText color="#FFFFFF80" size="10" text="Id:" />
            <TText color="white" size="10" :text="active_tree_element_process.id" />
          </template>
          <template #details_title_right v-if="active_tree_element_process">
            <TTooltip value="Close">
              <TIcon style="cursor: pointer;" name="sign-close" @click.native="active_tree_element_process = false" />
            </TTooltip>
            <TTooltip :value="child.minimized ? 'Open Details' : 'Minimize Details'">
              <TIcon style="cursor: pointer;" :name="child.minimized ? 'chevron-up' : 'chevron-down'" @click.native="resizeContainer(resize_id)" />
            </TTooltip>
          </template>

          <template #detail_breadcrumbs v-if="active_tree_element_process">
            <!-- {{ getObjectUrl(active_tree_element_process).path }} -->
            <div
              v-for="(parent, index) in getObjectUrl(active_tree_element_process).path"
              :key="`path${parent.type}${parent.id}`"
              style="display:flex;align-items:center;"
            >
            <TTooltip :value="$store.state.Ultra[parent.type][parent.id].name ? $store.state.Ultra[parent.type][parent.id].name : parent.type">
              <TIcon size="18" :name="$store.state.Ultra.icon_by_type[parent.type]" style="cursor:pointer;" @click.native="active_tree_element_process = $store.state.Ultra[parent.type][parent.id]" />
            </TTooltip>
              <TIcon size="18" name="chevron-right" v-if="getObjectUrl(active_tree_element_process).path.length > 1 && getObjectUrl(active_tree_element_process).path.length - 1 !== index" />
            </div>
          </template>

          <template #default="{ tab_content }" v-if="active_tree_element_process">
            <!-- details -->
            <div v-if="tab_content === 'details'">
              <div class="tree_details">
                <!-- TAKT Project-->
                <div v-if="active_tree_element_process.type === 'projects'">
                  <div class="basic-flex-row">
                    <TText :text="active_tree_element_process.name" font_weight="400" size="14" />
                  </div>
                  <TText :text="active_tree_element_process.description" size="12" />
                </div>

                <!-- TAKT Trains-->
                <div v-if="active_tree_element_process.type === 'trains'">
                  <div class="basic-flex-row">
                    <TText :text="active_tree_element_process.name" font_weight="400" size="14" />
                  </div>
                  <TText :text="active_tree_element_process.description" size="12" />
                </div>

                <!-- TAKT Areas-->
                <div v-if="active_tree_element_process.type === 'taktareas'" class="basic-flex-col">
                  <!-- Name + Description -->
                  <div>
                    <div class="basic-flex-row">
                      <TText :text="active_tree_element_process.name" font_weight="400" size="14" />
                    </div>
                    <TText :text="active_tree_element_process.description" size="12" />
                  </div>
                  
                </div>

                <!-- t Waggons-->
                <div v-if="active_tree_element_process.type === 'twaggons'">
                  <div class="basic-flex-row">
                    <TText :text="active_tree_element_process.token" font_weight="400" size="14" />
                  </div>
                </div>

                <!-- work packages -->
                <div v-if="active_tree_element_process.type === 'tworkpackages'">
                  <div :style="`display:flex; justify-content:space-between;width:100%;padding-left:4px;border-left:4px solid ${getColor(active_tree_element_process.color)}`">
                    <TText :text="active_tree_element_process.name" font_weight="400" size="14" />
                  </div>
                  <hr style="border-color:  #FFFFFF80;" >
                  <div class="source-and-takeover-filter-field">
                    <TTooltip value="Set to Filter (CTRL + click to add as new Filterline)">
                        <TIcon size="16" 
                            name="filter" style="cursor: pointer;"
                            @click.native.prevent.stop="takeoverFilter({
                              tree_type: 'process',
                              filtertype: 'filter_attr',
                              attributename: 'text',
                              value: active_tree_element_process.name,
                              event: $event
                            })"
                        />
                      </TTooltip>
                    <TText color="#FFFFFFB3" size="9" :value="'Name'" />
                  </div>
                  <TText :text="active_tree_element_process.description" size="12" />
                  <hr style="border-color:  #FFFFFF80;" >
                  <div class="source-and-takeover-filter-field">
                  <TText color="#FFFFFFB3" size="9" :value="'Description'" />
                  </div>
                </div>

                <!-- Work Steps -->
                <div v-if="active_tree_element_process.type === 'tworksteps'">
                  <TText :text="active_tree_element_process.text" size="12" />
                  <hr style="border-color:  #FFFFFF80;" >
                  <div class="source-and-takeover-filter-field">
                    <TTooltip value="Set to Filter (CTRL + click to add as new Filterline)">
                        <TIcon size="16" 
                            name="filter" style="cursor: pointer;"
                            @click.native.prevent.stop="takeoverFilter({
                              tree_type: 'process',
                              filtertype: 'filter_attr',
                              attributename: 'text',
                              value: active_tree_element_process.text,
                              event: $event
                            })"
                        />
                      </TTooltip>
                    <TText color="#FFFFFFB3" size="9" :value="'Name'" />
                  </div>
                </div>

                </div>
              </div>

              <div v-if="tab_content === 'shapes'">
                <!-- Shapes -->
                <div class="basic-flex-col">
                    <!-- Shapes Header -->
                    <div class="basic-flex-row mt-3">
                      <TText value="Taktarea Shapes" font_weight="400" size="14" />

                      <!-- selection for ALL shapes -->
                      <TTooltip v-if="taktareashapes.length" value="Add elements of all Shapes to selection">
                        <TIcon  
                          class="cursor-pointer"
                          name="checkbox-radial-empty" 
                          @click.native.prevent.stop="getAllShapesElements()"
                        />

                      </TTooltip>

                      <TTooltip v-if="active_tree_element_process.type === 'taktareas' && ui_mode === 'edit'" value="Add Shape">
                        <ButtonOutlined
                          height="24" 
                          width="24"
                          icon="sign-plus"
                          @buttonClicked="createUObject({
                            url: [
                              { projects: project_id },
                              { trains: active_tree_element_process.parent.id },
                              { taktareas: active_tree_element_process.id },
                              { taktareashapes: '' },
                              { showWithEntitiesNormalized: '' }
                            ],
                            u_object: {
                               name: `Shape #${active_tree_element_process.taktareashapes.length + 1}`, 
                               description: 'No Description', 
                               geometry: { 
                                type: 'ExtrudedShape',
                                extrude_value: 10,
                                points_x: [],
                                points_y: [],
                                points_z: [],
                                offset: [0,0,0],
                                normal: [0,0,1],
                                max_points: false,
                                min_points: 3,
                                path_length: 0,
                              }
                            }
                          })"
                        />
                      </TTooltip>
                    </div>
                    <!-- Shapes Body -->
                    <div class="basic-flex-col">
                      <!-- {{ active_tree_element_process }} -->
                      <div 
                        v-for="shape in taktareashapes"
                        :key="`taktareashape${shape.id}`"
                        class="basic-flex-row mt-2"
                      >
                        <TContextMenu 
                          :menu_items="[{key: all_taktareas, text: 'Move'}, {key: all_taktareas, text: 'Copy'}]" 
                          @selectMenuItem="selectMenuItemShapes($event, shape)"
                        >
                          <div class="basic-flex-col">
                            <TText :text="shape.name" font_weight="300" size="12" />
                            <TText :text="getUObject({ type: shape.parent.type, id: shape.parent.id}).name" size="10" />
                          </div>
                        </TContextMenu>
                        <!-- <DisableableInputField label="Height"
                        v-if="shape.geometry.extrude_value"
                        :is_disabled="ui_mode !== 'edit' || active_tree_element_process.type !== 'taktareas'" width="64px"
                        :value="shape.geometry.extrude_value" background_color="rgba(39, 39, 39, 0.7)" 
                        @change="updateUObject({
                          url: [
                            { projects: project_id },
                            { trains: active_tree_element_process.parent.id },
                            { taktareas: active_tree_element_process.id },
                            { taktareashapes: shape.id },
                          ],
                          update: {
                            geometry: Object.assign(shape.geometry, { extrude_value: parseFloat($event) })
                          }
                        }).then(() => {
                          updateTaktareashapeMesh({shape: shape, type: 'extrude_value', value: parseFloat($event)})
                        })" />
                        <DisableableInputField label="Z-Level"
                          v-if="shape.geometry.offset"
                          :is_disabled="ui_mode !== 'edit' || active_tree_element_process.type !== 'taktareas'" width="64px"
                          :value="shape.geometry.offset[1]" background_color="rgba(39, 39, 39, 0.7)" @change="updateUObject({
                            url: [
                              { projects: project_id },
                              { trains: active_tree_element_process.parent.id },
                              { taktareas: active_tree_element_process.id },
                              { taktareashapes: shape.id },
                            ],
                            update: {
                              geometry: Object.assign(shape.geometry, { offset: [0, parseFloat($event), 0] })
                            }
                          }).then(() =>
                            updateTaktareashapeMesh({shape: shape, type: 'offset', value: parseFloat($event)})
                          )" /> -->
                          <!-- selection -->
                          <TTooltip v-if="!(edit_geometry_object.type === 'taktareashapes' && edit_geometry_object.id === shape.id)" value="Add elements to selection">
                            <TIcon  
                              class="cursor-pointer"
                              name="checkbox-radial-empty" 
                              @click.native.prevent.stop="getShapesElements(shape)"
                            />

                          </TTooltip>
                          <TTooltip v-if="ui_mode === 'edit' && !is_edit_geom" value="Edit shape">
                            <TIcon  
                              class="cursor-pointer"
                              :name="edit_geometry_object.type === 'taktareashapes' && edit_geometry_object.id === shape.id?'check-circle':'pencil'"
                              @click.native.prevent.stop="
                                edit_geometry_object.type === 'taktareashapes' && edit_geometry_object.id === shape.id?
                                  endEditGeometry(
                                    edit_geom.points_x.length > 2?true:false, 
                                    false, 
                                    edit_geometry_object.url
                                    )
                                    :
                                    (shape.geometry.points_x.length >2?
                                      startEditGeometry(
                                        shape,
                                        [
                                          { projects: project_id },
                                          { trains: active_tree_element_process.parent.id },
                                          { taktareas: active_tree_element_process.id },
                                          { taktareashapes: shape.id },
                                        ]
                                        )
                                      :
                                      createGeometry(
                                        shape, 
                                        [
                                          { projects: project_id },
                                          { trains: active_tree_element_process.parent.id },
                                          { taktareas: active_tree_element_process.id },
                                          { taktareashapes: shape.id },
                                        ],
                                        'ExtrudedShape', 
                                        false
                                        ))
                                    "
                            />
                          </TTooltip>
                          <TText 
                            v-if="edit_geometry_object.type === 'taktareashapes' && edit_geometry_object.id === shape.id"
                            value="editing"
                          />
                          <!-- visibility -->
                          <!-- <template v-if="shape.geometry.points_x.length > 2">
                          <TIcon  
                            name="visibility-on" 
                          />
                         </template> -->
                          <!-- delete -->
                          <TTooltip v-if="active_tree_element_process.type === 'taktareas' && ui_mode === 'edit' && !(edit_geometry_object.type === 'taktareashapes' && edit_geometry_object.id === shape.id)" value="Delete shape">
                          <TIcon
                            :is_disabled="ui_mode !== 'edit'"
                            name="bin-delete"
                            :class="{'cursor-pointer' : ui_mode === 'edit' }"
                            @click.native.prevent.stop="ui_mode === 'edit' ? deleteUObject({
                              url: [
                                { projects: project_id },
                                { trains: active_tree_element_process.parent.id },
                                { taktareas: active_tree_element_process.id },
                                { taktareashapes: shape.id },
                              ],
                            }).then(() => {
                              shape.geometry.points_x.length >2?removeUnstagedShapeMeshes(shape.id):''
                            }) : null"
                          />
                        </TTooltip>
                        
                      </div>
                    </div>
                  </div>
              </div>

              <!-- ta_elements-->
              <div v-else-if="tab_content === 'ta_elements'">
                <template v-if="isObjectFullFetched(active_tree_element_process)">
                  <!-- now in tree component -->
                  <!-- <div class="tree-header-bar">
                    <ProjectStructureToggleContent icon="horizontal-dots">
                      <div class="toggle_items"
                        v-for="(setting, index) in Object.keys($store.state.ProjectStructure.tree_settings_wrapper.taktarea_elements)"
                        :key="index">
                        <RadialCheckbox foreground_color="white"
                          :is_checked="$store.state.ProjectStructure.tree_settings_wrapper.taktarea_elements[setting]"
                          @setActive="updateSetting({ type: 'wrapper', tree: 'taktarea_elements', setting: setting, value: !$store.state.ProjectStructure.tree_settings_wrapper.taktarea_elements[setting] })" />
                        <TIcon :name="$store.state.Ultra.icon_by_type[setting]" />
                        {{ setting }}
                      </div>
                    </ProjectStructureToggleContent>
                    <SearchBar underscored min_height="auto" @search="search = $event" />
                  </div> -->
                  <ProjectStructureTree 
                    tree_type="spatial" 
                    tree_name="taktarea_elements"
                    tree_title="LINKED AREA ELEMENTS"
                    :collection_object="getAllChildObjectIds({ parent: active_tree_element_process, tree_type: 'process', targets: ['ta_elements'] })"
                    :object="project" 
                    :depth="1" 
                    :targets="['ta_elements']"
                    @clickHeader="handleClickHeader('spatial', $event)">
                  </ProjectStructureTree>
                </template>
                <div v-else><TText value="loading..." /></div>
              </div>
              <!-- elements -->
              <div v-else-if="tab_content === 'elements'">
                <template v-if="isObjectFullFetched(active_tree_element_process)">
                  <!-- now in tree component -->
                  <!-- <div class="tree-header-bar">
                    <ProjectStructureToggleContent icon="horizontal-dots">
                      <div class="toggle_items"
                        v-for="(setting, index) in Object.keys($store.state.ProjectStructure.tree_settings_wrapper.step_elements)"
                        :key="index">
                        <RadialCheckbox foreground_color="white"
                          :is_checked="$store.state.ProjectStructure.tree_settings_wrapper.step_elements[setting]"
                          @setActive="updateSetting({ type: 'wrapper', tree: 'step_elements', setting: setting, value: !$store.state.ProjectStructure.tree_settings_wrapper.step_elements[setting] })" />
                        <TIcon :name="$store.state.Ultra.icon_by_type[setting]" />
                        {{ setting }}
                      </div>
                    </ProjectStructureToggleContent>
                    <SearchBar underscored min_height="auto" @search="search = $event" />
                  </div> -->
                  <ProjectStructureTree 
                    tree_type="spatial" 
                    tree_name="step_elements"
                    tree_title="LINKED STEP ELEMENTS"
                    :collection_object="getAllChildObjectIds({ parent: active_tree_element_process, tree_type: 'process', targets: ['elements'] })"
                    :object="project" 
                    :depth="1" 
                    :targets="['elements']"
                    @clickHeader="handleClickHeader('spatial', $event)"
                    >
                  </ProjectStructureTree>
                </template>
                <div v-else><TText value="loading..." /></div>
              </div>

          </template>
          <template #default v-else>
          </template>
        </ProjectStructureDetails>
      </template>
    </ProjectStructureFrame>
  </div>
</template>

<script>
import store from '@/store/index';
import { mapState, mapGetters, mapActions } from 'vuex';

import { IfcInitializeMixin } from '@/mixins/IfcInitialize.mixin.js'
import { TColor } from '@/mixins/TColor.mixin.js';

import ProjectStructureFrame from '@/components/ProjectStructureRework/ProjectStructureFrame.component.vue';
import ProjectStructureTreeContainer from '@/components/ProjectStructureRework/ProjectStructureTreeContainer.component.vue';
import ProjectStructureTree from '@/components/ProjectStructureRework/ProjectStructureTree.component.vue';
import ProjectStructureDetails from '@/components/ProjectStructureRework/ProjectStructureDetails.component.vue';
import FilterHeader from '@/components/ProjectStructureRework/FilterHeader.component.vue';
import ProjectStructureFilter from '@/components/ProjectStructureRework/ProjectStructureFilter.component.vue';
import SectionSettings from '@/components/ProjectStructureRework/SectionSettings.component.vue';

import ProjectStructureElementPropSet from '@/components/ProjectStructureRework/ProjectStructureElementPropSet.component.vue';
// import ProjectStructureToggleContent from '@/components/ProjectStructureRework/ProjectStructureToggleContent.component.vue';

import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue'
import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue';
import ClickablePopUpIcon from '@/components/WorkPackageWIP/ClickablePopUpIcon.component.vue';

import RadioButtonTextGroup from '@/components/WorkPackageWIP/RadioButtonTextGroup.component.vue'

import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue'
import TProgressBar from '@/components/Taktify/TProgressBar.component.vue';
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import InputAndSourceField from '@/modules/General/InputAndSourceField.module.vue';

import TIcon from '@/components/Taktify/TIcon.component.vue'
import TSearchField from '@/components/Taktify/TSearchField.component.vue'
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
// import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue'
import TransitionFade from '@/components/WorkPackageWIP/TransitionFade.component.vue';
import TContextMenu from '@/components/Taktify/TContextMenu.component.vue';

// import { WalletMixin } from '@/mixins/Wallet.mixin.js'


export default {
  props: [],
  data: () => ({
    filter_object_spatial: [{type: 'filter_attr', attributename: 'ifc_type', operator: '===', value: '', active: true}],
    filter_object_process: [{type: 'filter_attr', attributename: 'text', operator: '===', value: '', active: true}],
    active_tree_element_spatial: false,
    active_tree_element_process: false,
    filter_management: {
      tab: 'custom',
      type: 'spatial',
      search: '',
      new_filter: {
        name: '',
        project: null
      }
    },
    process_selection_type: 'taktareas',
    show_toggle_content: false,
    loading_structure: true,
    spatial_details_popup: false,
    checked: [],
    link_feedback: {
      active: false,
      text: '',
    },

    new_spatial_object: {
      type: 'elements',
      name: '',
      ifc_type: 'IFCBUILDINGELEMENTPROXY',
      description: '',
      count: 1,
      height: 0,
      width: 0,
      length: 0,
      volume: 0,
      floor_area: 0,
      side_area: 0,
      perimeter: 0,
      surface: 0,
      lateral_surface: 0,
      weight: 0,
    },

    // IFC IMPORT
    selected_import_strategy: { value: 'default' },
    importing_ifc: {
      importing: false,
      ifc_size: 1,
    },
    ifc_upload_done: false,

    // 4D simulation
    current_4d_takt: 0,
    cumulative_4d: false,


    // Bereits + Icon in:
    // $store.state.Ultra.ifc_wrapper
    tree_objects_spatial: [
      'sites',
      'spatialzones',
      'buildings',
      'buildingstoreys',
      'spacegroups',
      'elementassemblies',
      'elements'
    ],
    show_tree_objects_spatial: {
      projects: true,
      sites: true,
      spatialzones: true,
      buildings: true,
      buildingstoreys: true,
      spacegroups: true,
      element_wrapper: true,

      elementassemblies: true,
      elements: true,
    },
    tree_objects_process: [
      'trains',
      'taktareas',
      'twaggons',
      'tworkpackages',
      'tlogisticsteps',
      'tdesignsteps',
      'tworksteps',
      'tqualitysteps',
      'tdefectsteps',
      'thandoversteps',
      'tmachinesteps',
    ],
    show_tree_objects_process: {
      projects: true,
      trains: true,
      taktareas: true,
      twaggons: true,
      tworkpackages: true,

      tlogisticsteps: true,
      tdesignsteps: true,
      tworksteps: true,
      tqualitysteps: true,
      tdefectsteps: true,
      thandoversteps: true,
      tmachinesteps: true,
    },
    tree_spatial: { children: [] },
    tree_process: { children: [] },

    struct_modes: [
      { title: 'Zuweisungs Mode', state: 'view', icon: 'takt-plan', text: 'Um IFC-Elemente auszuwählen und dem Prozess zuzuweisen', shortcut: 'ctrl + Tab' },
      { title: 'TAKT-Zuweisungs Mode', state: 'link', icon: 'takt-structure', text: 'Um Prozess-Elemente auszuwählen und dem IFC zuzuweisen', shortcut: 'ctrl + Tab' },
      { title: 'Time Mode', state: 'time', icon: 'stopwatch', text: 'Um Zugewisene Elemente im zeitlichen Ablauf zu visualisieren', shortcut: 'ctrl + t' },
      { title: 'Evaluation Mode', state: 'evaluation', icon: 'file-check', text: 'Um Projektverläufe und Erfolge visuell darzustellen', shortcut: 'ctrl + e' },
      { title: 'Edit Mode', state: 'edit', icon: 'pencil', text: 'Um Elemente zu bearbeiten', shortcut: 'ctrl + Tab' }
    ],
    side_buttons: [
      { type: 'center-model', icon: 'area-empty', text: 'Center Model', clicked: false },
      { type: 'show-invisble-elements', icon: 'visibility-off', text: 'Show Invisible Elements', clicked: false },
      { type: 'presentation-mode', icon: 'cube-negative', 
        icons: [
          'cube-negative', 'cube-top', 'cube',
        ],
        text: 'Presentation Mode', clicked: false, selected_button: 2 },
      { type: 'sections-horizontal', icon: 'plate', text: 'Sections Horizontal', state: 'normal', clicked: false},
      { type: 'sections-vertical-x', icon: 'wall-perspective', text: 'Sections Vertical X', state: 'normal', clicked: false},
      { type: 'sections-vertical-y', icon: 'wall-perspective', text: 'Sections Vertical Y', state: 'normal', clicked: false},
      { type: 'zoom-to-visible', icon: 'magnifying-glass', text: 'Zoom to visible Objects', clicked: false },
      { type: 'toggle-orbit-target', icon: 'globe', text: 'Toggle Orbit Target visibility (set position of Orbit Target with click + SHIFT)', clicked: false },
    ],
    selection_buttons: [
      {
        title: 'Apply IFC-Selection to TAKT.Area', icon_left: 'proxy', icon_right: 'takt-plan-train',
        text: 'Zum Verküpfen der links gewählten IFC-Elemente mit den rechts gewählten TAKT.Area', shortcut: 'ctrl + h?'
      },
      {
        title: 'Apply IFC-Selection to WORK.Step Selection', icon_left: 'proxy', icon_right: 'takt-plan-waggon',
        text: 'Zum Verküpfen der links gewählten IFC-Elemente mit den rechts gewählten WORK.Step Sammlung', shortcut: 'ctrl + h?'
      },
      {
        title: 'Apply IFC-Selection to WORK.Step', icon_left: 'proxy', icon_right: 'takt-plan-workpackage',
        text: 'Zum Verküpfen der links gewählten IFC-Elemente mit den rechts im Prozess-Detail gewählten WORK.Step', shortcut: 'ctrl + h?'
      },
      {
        title: 'Apply IFC-Element to TAKT.Area', icon_left: 'area-shaded', icon_right: 'takt-plan-train',
        text: 'Zum Verküpfen des links im Detail gewählten IFC-Elementes mit den rechts gewählten TAKT.Area', shortcut: 'ctrl + h?',
        text2: 'Zum Verküpfen bitte rechts im Detail eine TAKT.Area auswählen',
      },
      {
        title: 'Apply IFC-Element to WORK.Step Selection', icon_left: 'area-shaded', icon_right: 'takt-plan-waggon',
        text: 'Zum Verküpfen der links im Detail gewählten IFC-Elementes mit den rechts gewählten  WORK.Step Sammlung', shortcut: 'ctrl + h?',
        text2: 'Zum Verküpfen bitte im mittleren Bereich eine WORK.Step Sammlung auswählen',
      },
      {
        title: 'Apply IFC-Element to WORK.Step', icon_left: 'area-shaded', icon_right: 'takt-plan-workpackage',
        text: 'Zum Verküpfen des links im Detail gewählten IFC-Elemente mit dem rechts im Detail gewählten WORK.Step', shortcut: 'ctrl + h?',
        text2: 'Zum Verküpfen bitte rechts im Detail einen WORK.Step auswählen',
      },
      {
        title: 'Unlink active IFC-Element from selected WORK.Steps or TAKT.Areas', icon_left: 'area-shaded', icon_right: 'logout',
        text: 'Zum Entküpfen des links im Detail gewählten aktiven IFC-Elemente mit den ausgewählten WORK.Steps oder TAKT.Areas in der Verlinkten Auflistung', shortcut: 'ctrl + h?'
      },

    ],
    local_view_filter: [
      { title: 'hide already connected', state: 'false', type: 'filter' },
      { title: 'hide not connected', state: 'false', type: 'filter' },
      { title: 'hide visible', state: 'false', type: 'filter' },
      { title: 'hide not visible', state: 'false', type: 'filter' },
    ],
    local_sort_filter: [
      { title: 'downwards', isDownwards: 'true', icon: 'arrow-down', },
      { title: 'upwards', isUpwards: 'false', icon: 'arrow-up', },
    ],
    active_struct_mode: {
      title: 'Zuweisungs Mode', icon: 'takt-plan', state: 'view',
      text: 'Um IFC-Elemente auszuwählen und dem Prozess zuzuweisen', shortcut: 'ctrl + Tab'
    },

    // multiWindow with LocalStorage
    vueMultiWindowProjectstructure: JSON.parse(localStorage.getItem('multiWindow')) || {},
    // _____________________________________________________________________
    multiWindowId: parseInt(sessionStorage.getItem('multiWindowId'), 10),

  }),
  mixins: [
    IfcInitializeMixin,
    TColor,
    // WalletMixin,
  ],
  components: {
    ProjectStructureFrame,
    ProjectStructureTreeContainer,
    ProjectStructureTree,
    ProjectStructureDetails,
    ProjectStructureElementPropSet,
    FilterHeader,
    ProjectStructureFilter,
    TIcon,
    RadialCheckbox,
    // SearchBar,
    StandardDialog,
    RadioButtonTextGroup,
    DropDownOutlinedFlat,
    TProgressBar,
    DisableableInputField,
    TransitionAccordion,
    PopUpOverlay,
    ClickablePopUpIcon,
    // ProjectStructureToggleContent,
    TTooltip,
    ButtonOutlined,
    InputAndSourceField,
    TransitionFade,
    TSearchField,
    SectionSettings,
    TContextMenu,
  },
  created() {
    this.initializeTreeSettings();
    this.requestUObject({
      url: [
        { structurefilters: '' },
        { showWithEntitiesNormalized: ''}
      ],
    })
  },
  mounted() {
    this.resizeContainer('splitable-resize-container-child-project-structure-frame-content-left-1-resizer');
    this.resizeContainer('splitable-resize-container-child-project-structure-frame-content-right-1-resizer');

    // multiWindow with LocalStorage
    // window.addEventListener('beforeunload', this.removeWindowFromLocalStorage);
    window.addEventListener('storage', this.handleStorageChange); 
    // console.log(this.multiWindowId);
    // _____________________________________________________________________

    this.initializeScene();
    // REQUEST IMPORT STRATEGIES
    this.requestBusiness();

    let promises = [
         // request project elements and steps
        this.requestProjectElements(this.project_id),
        this.requestProjectSteps(this.project_id),
    ];
    Promise.allSettled(promises).then(() => {
      let promises2 = [
        // request ta elements and save it to tas in ultra store
        this.requestUObject({
          url: [
            { projects: this.project_id },
            { taktareaselements: '' }
          ],
        }),
        //request projectstucture
        this.requestUObject({
          url: [
            { projects: this.project_id },
            { projectstructure: '' }
          ],
        }),
        //request project with steps
        this.requestUObject({
          url: [
            { projects: this.project_id },
            { showWithSteps: '' }
          ],
        }),
      ];
      Promise.allSettled(promises2).then(() => {
        this.loading_structure = false;
        // this.createTree('spatial');
        // this.createTree('process');
        this.sceneLoadModels();
        this.initializeProcessParents(this.project_id)
      });
    });
  },
  watch: {
    active_tree_element_spatial_id_string(val) {
      // hard coded id:  splitable-resize-container-child-project-structure-frame-content-left-1-resizer
      const resize_id = 'splitable-resize-container-child-project-structure-frame-content-left-1-resizer';
      if (val === false) {
        this.resizeContainer(resize_id);
      }

      if (val && !['object_wrapper', 'projects'].includes(this.active_tree_element_spatial.type) && this.$store.state.Ultra[this.active_tree_element_spatial.type]) {
        this.requestUObject({
          url: [
            { [this.active_tree_element_spatial.type]: this.active_tree_element_spatial.id },
            { showWithEntitiesNormalized: '' }
          ],
          url_prefix: `/projects/${this.project_id}/projectstructure`,
          no_cache: false
        }).then(() => {
          // set active tree el to new created merged object
          this.active_tree_element_spatial = this.$store.state.Ultra[this.active_tree_element_spatial.type][this.active_tree_element_spatial.id];
          // wait for the change
          this.$nextTick(() => {
            this.updateUDObject({
              url: [
                { [this.active_tree_element_spatial.type]: this.active_tree_element_spatial.id }
              ],
              update: {
                full_fetched: true,
              }
            });
          })
        })
      }
    },
    active_tree_element_process_id_string(val) {
      // hard coded id:  splitable-resize-container-child-project-structure-frame-content-right-1-resizer
      const resize_id = 'splitable-resize-container-child-project-structure-frame-content-right-1-resizer';
      if (val === false) {
        this.resizeContainer(resize_id);
      }

      if (val && !['object_wrapper', 'projects'].includes(this.active_tree_element_process.type) && this.$store.state.Ultra[this.active_tree_element_process.type]) {
        let url_copy = JSON.parse(JSON.stringify(this.getObjectUrl(this.active_tree_element_process).url));
        url_copy.push({ showWithEntitiesNormalized: '' });
        this.requestUObject({
          url: url_copy,
          no_cache: false
        }).then(() => {
          // set active tree el to new created merged object
          this.active_tree_element_process = this.$store.state.Ultra[this.active_tree_element_process.type][this.active_tree_element_process.id];
          // wait for the change
          this.$nextTick(() => {
            this.updateUDObject({
              url: [
                { [this.active_tree_element_process.type]: this.active_tree_element_process.id }
              ],
              update: {
                full_fetched: true,
              }
            });
          })
        })
      }
    },
    project_structure_create_dialog(val){
      if (val.show && this.project_structure_create_dialog.object && this.project_structure_create_dialog.object.type === 'projects') {
        this.new_spatial_object.type = 'sites';
      }
    },
    
    // multiWindow with LocalStorage
    /**
     * After completing the loading process, create the desired view in the multiWindow if the project ID matches
     * Caution: sometimes different data types under route.params.project_id
     * @param {*} newValue 
     */
    model_is_loading(newValue) {
      if (newValue === false && this.multiWindowId && !isNaN(this.multiWindowId) && this.vueMultiWindowProjectstructure.active_element.project_id==this.$route.params.project_id) {
        // console.log('finished Loading Model');
        this.takeoverActiveElementToProjectstructure();
      }
    },
    
    /**
     * Recognize changes to the active element in data of this view and trigger processing for Projectstructure
     */
    'vueMultiWindowProjectstructure.active_element': {
      deep: true,
      handler() {
        // Prüfung ob es ein Child multiWindow ist und ob die ProjektID übereinstimmt
        // Achtung z.T. unterschiedliche Datentypen unter route.params.project_id
        if (this.multiWindowId && !isNaN(this.multiWindowId) && this.vueMultiWindowProjectstructure.active_element.project_id==this.$route.params.project_id) {
          // console.log('Änderung an vueMultiWindowProjectstructure.active_element erkannt');
          this.takeoverActiveElementToProjectstructure();
        }
        else {
          console.error('Change to vueMultiWindowProjectstructure.active_element ignored because ProjectID is different or multiWindowId does not exist.');
        }
      }
    },
    // _____________________________________________________________________

  },
  computed: {
    ...mapState('ProjectStructure', [
      'selected_elements',
      'selected_steps',
      'filter',
    ]),
    ...mapState('View', [
      'project_structure_create_dialog',
    ]),
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObject',
    ]),
    ...mapGetters('ProjectCalendar', [
      'getDatesFromTaktIndex',
      'hasCalendar',
    ]),
    ...mapGetters('Auth', [
      'hasPermission',
    ]),
    ...mapGetters('ProjectStructure', [
      'getImportStrategies',
      'getLinkedProcessObjectIds',
      'getLinkedSpatialObjectIds',
      'getAllChildObjectIds',
      'isSet1inSet2',
      'getObjectUrl',
      'getForegroundColor',
      'getBackgroundColor',
      'getCollectionParents',
      'getIfcElementTypes',
      'isSet1LinkedToSet2',
    ]),
    structure_filters(){

      let filters = this.getUObjects({type: 'structurefilters'});

      filters = filters.filter(filter => filter.type === this.filter_management.type);

      if (this.filter_management.tab === 'project') {
        filters = filters.filter(filter => filter.project_id === this.project_id)
      }

      if (this.filter_management.search !== '') {
        filters = filters.filter(filter => filter.name.toLowerCase().includes(this.filter_management.search.toLowerCase()))
      }

      return filters;
    },
    ui_mode(){
      return this.$store.state.ProjectStructure.ui_mode;
    },
    all_taktareas(){
      let taktareas = [];
      const trains = this.getUObjects({ type: 'trains', ids: this.project.trains });
      trains.forEach(train => {
        const tas = this.getUObjects({ type: 'taktareas', ids: train.taktareas });
        tas.forEach(ta => {
          taktareas.push({
            text: `${train.name}/${ta.name}`,
            key: `taktarea_${ta.id}`
          });
        })
      });
      return taktareas;
    },
    active_tree_element_spatial_id_string() {
      if (this.active_tree_element_spatial) {
        return `${this.active_tree_element_spatial.type}#${this.active_tree_element_spatial.id}`;
      } else {
        return false;
      }
    },
    active_tree_element_process_id_string() {
      if (this.active_tree_element_process) {
        return `${this.active_tree_element_process.type}#${this.active_tree_element_process.id}`;
      } else {
        return false;
      }
    },
    active_linked_ta_elements() {
      if (this.active_tree_element_process) {
        return this.getAllChildObjectIds({ parent: this.active_tree_element_process, tree_type: 'process', targets: ['ta_elements'] });
      } else {
        return { ta_elements: [] };
      }
    },
    active_linked_elements() {
      if (this.active_tree_element_process) {
        return this.getAllChildObjectIds({ parent: this.active_tree_element_process, tree_type: 'process', targets: ['elements'] });
      } else {
        return { elements: [] };
      }
    },
    active_shapes() {
      if (this.active_tree_element_process) {
        return this.getAllChildObjectIds({ parent: this.active_tree_element_process, tree_type: 'process', targets: ['taktareashapes'] });
      } else {
        return { taktareashapes: [] };
      }
    },
    has_selected_steps() {
      let has_steps = false;
      Object.keys(this.selected_steps).forEach(type => {
        if (this.selected_steps[type].length !== 0) {
          has_steps = true;
          return;
        }
      })
      return has_steps;
    },
    selected_steps_count() {
      if (this.process_selection_type === 'taktareas') {
        return this.getCollectionParents({collection_object: this.$store.state.ProjectStructure.selected_steps, target_types: ['taktareas']}).taktareas.length;
      }
      // else
      let count = 0;
      Object.keys(this.selected_steps).forEach(type => {
        count += this.selected_steps[type].length;
      })
      return count;
    },
    project_id() {
      return parseInt(this.$route.params.project_id);
    },
    project() {
      return store.state.Ultra.projects[this.$route.params.project_id];
    },
    selectionLinkingResp() {
      let set1 = {type: 'ids_by_target', value: this.selected_elements};
      let targets;
      let set2;
      if (this.process_selection_type === 'taktareas') {
        set2 = {type: 'ids_by_target', value: {taktareas: this.getCollectionParents({collection_object: this.$store.state.ProjectStructure.selected_steps, target_types: ['taktareas']}).taktareas}};
        targets = ['ta_elements'];
      } else {
        set2 = {type: 'ids_by_target', value: this.selected_steps};
        targets = ['elements'];
      }
      let resp = this.isSet1LinkedToSet2({
        set1: set1,
        set2: set2,
        targets: targets
      });
      return resp;
    },
    link_btn_text() {
      let text = 'link';
      switch (this.selectionLinkingResp.result) {
        case 'complete':
          text = 'unlink' 
          break;
        case 'none':
          text = 'link' 
          break;
        case 'part':
          text = 'complete link' 
          break;
      
        default:
          break;
      }
      return text;
    },
    taktareashapes(){
      if (this.active_tree_element_process.type === 'taktareas') {
        return this.getUObjects({ type: 'taktareashapes', ids: this.active_tree_element_process.taktareashapes })
      } else {
        const ids = this.getAllChildObjectIds({parent: this.active_tree_element_process, tree_type: 'process', targets: ['taktareashapes']}).taktareashapes;
        return this.getUObjects({ type: 'taktareashapes', ids: ids })
      }
    },
    takt_date_for_4d(){
      if (this.ui_mode !== '4d') {
        return 'Not 4D mode';
      }
      const dates = this.getDatesFromTaktIndex({ project_id: this.project_id, takt_index: this.current_4d_takt, chronology: 'before' });
      if (dates.length > 1) {
        const first_date = dates[0];
        const last_date = dates[dates.length - 1];
        return `${first_date.toDateString()} - ${last_date.toDateString()}`;
      } else {
        return dates[0].toDateString();
      }
    },
    new_spatial_object_available_types(){
      let types = [
        { text: 'Element', value: 'elements', },
      ];
      switch (this.project_structure_create_dialog.object.type) {
        case 'sites':
          types.push({ text: 'Site', value: 'sites', });          
          types.push({ text: 'Spatial Zone', value: 'spatialzones', });          
          types.push({ text: 'Building', value: 'buildings', });          
          break;
        case 'spatialzones':
          types.push({ text: 'Spatial Zone', value: 'spatialzones', });          
          break;
        case 'buildings':
          types.push({ text: 'Building', value: 'buildings', });          
          types.push({ text: 'Building Storey', value: 'buildingstoreys', });          
          types.push({ text: 'Space', value: 'spacegroups', });          
          break;
        case 'buildingstoreys':
          types.push({ text: 'Building Storey', value: 'buildingstoreys', });          
          types.push({ text: 'Space', value: 'spacegroups', });          
          break;
        case 'spacegroups':
          types.push({ text: 'Space', value: 'spacegroups', });          
          break;
        case 'projects':
          types = [
            { text: 'Site', value: 'sites' }
          ];
          break;
      }

      return types;
    }
    // active_tree_element_process_long() {
    //   if (this.$store.state.Ultra[this.active_tree_element_process.type]) {
    //     let el = this.$store.state.Ultra[this.active_tree_element_process.type][this.active_tree_element_process.id];
    //     if (el) {
    //       el.type = this.active_tree_element_process.type;
    //       return el;
    //     } else {
    //       return false;
    //     }
    //   } else {
    //     return false;
    //   }
    // },
  },
  methods: {
    ...mapActions('Ultra', [
      'requestUObject',
      'updateUObjectParent',
      'createUObject',
      'deleteUObject',
      'updateUObject',
      'updateUObjectRelations',
    ]),
    ...mapActions('UltraDev', [
      'updateUDObject',
    ]),
    ...mapActions('View', [
      'setValue',
    ]), 
    ...mapActions('ProjectStructure', [
      'planDetectRoomsCall',
      'requestProjectElements',
      'requestProjectSteps',
      'initializeTreeSettings',
      'updateSetting',
      'initializeProcessParents',
      'importIFCNew',
      'setUiMode',
      'linkObjects',
      'updateProjectStructureValue',
      'requestProjectElementsFiltered',
      'requestProjectStepsFiltered',
      'showElementsByTakt',
      'toggleFilter'
    ]),
    // TODO Anpassungen nicht vergessen, für Process detail 
    // getLinkedIFCDetail(element_id) {
    //   if (this.$store.state.Ultra.elements[element_id]) {
    //     return this.$store.state.Ultra.elements[element_id];
    //   }
    //   else {
    //     return this.$store.state.ProjectStructure.project_elements[element_id];
    //   }
    // },
    saveFilter(){

      let payload = Object.assign({}, this.filter_management.new_filter);

      let filter_payload = JSON.parse(JSON.stringify(this[`filter_object_${this.filter_management.type}`]));
      payload.settings = filter_payload;
      payload.owner = true;
      payload.type = this.filter_management.type;

      this.createUObject({
        url: [
          { structurefilters: ''},
          { showWithEntitiesNormalized: '' }
        ],
        u_object: payload
      }).then(() => {
        this.filter_management.tab = 'custom';
        this.filter_management.new_filter = {
          name: '',
          project_id: null
        }
      });
    },
    selectMenuItemShapes(payload, shape){
      if (payload.item.text === 'Move') {
        // taktarea_id is payload.key without "taktarea_"
        const taktarea_id = parseInt(payload.item_2.key.split('_')[1]);
        const taktarea = this.getUObject({type: 'taktareas', id: shape.parent.id});
        this.updateUObjectParent({
          url: [
            {projects: this.project_id},
            {trains: taktarea.parent.id},
            {taktareas: taktarea.id},
            {taktareashapes: shape.id},
            {updateparent: ''}
          ],
          update: {
            parent_id: taktarea_id,
          }
        })
      }

      if (payload.item.text === 'Copy') {

        const taktarea_id = parseInt(payload.item_2.key.split('_')[1]);
        const taktarea = this.getUObject({type: 'taktareas', id: taktarea_id});

        this.createUObject({
          url: [
            { projects: this.project_id },
            { trains: taktarea.parent.id },
            { taktareas: taktarea.id },
            { taktareashapes: '' },
            { showWithEntitiesNormalized: '' }
          ],
          u_object: {
              name: shape.name, 
              description: shape.description, 
              geometry: shape.geometry,
          }
        })
      }
    },
    requestBusiness() {
        let current_user = this.$store.getters['Auth/getUser'];
        if (current_user.business.id) {
          this.requestUObject({
            url: [
              {businesses: current_user.business.id},
              {showWithEntitiesNormalized: ''}
            ]
          }).then(() => {
            this.requestUObject({
              url: [
                {businesses: current_user.business.id},
                {bifcimportstrategies: ''},
                {showWithEntitiesNormalized: ''}
              ],
              add_u_object: true
            })
          })
        }
      },
    handleLinkObjects(action){
      // action: link / unlink / auto
      let selection_result;

      switch (action) {
        case 'link':
          selection_result = 'add';
          break;
        case 'unlink':
          selection_result = 'remove';
          break;
        default:
          selection_result = this.selectionLinkingResp.result;
          break;
      }

      if (selection_result !== 'complete') {
        this.link_feedback.text = 'Linking was successful'
      } else {
        this.link_feedback.text = 'Unlinking was successful'
      }

      this.linkObjects({
        project_id: this.project_id,
        action: ['complete', 'add'].includes(selection_result) ? 'add':'remove',
        elements: this.selected_elements.elements,
        tworksteps: this.selected_steps.tworksteps,
        taktareas: this.getCollectionParents({collection_object: this.$store.state.ProjectStructure.selected_steps, target_types: ['taktareas']}).taktareas,
        link_target: this.process_selection_type //taktareas || steps
      }).then(() => {
        this.link_feedback.active = true;

        this.setCollectionObjects({
            action: 'set',
            ids_by_target: {elements: []},
            collection_name: 'selected_elements', // visible, selected
        });

        this.setCollectionObjects({
            action: 'set',
            ids_by_target: {tworksteps: []},
            collection_name: 'selected_steps', // visible, selected
        });

        // after 2 seconds set feedback to inactive
        let self = this;
        setTimeout(() => {
          self.link_feedback.active = false;
        }, 2000);

      })
    },
    resizeContainer(resize_id) {
      let container = document.getElementById(resize_id);
      var clickEvent = document.createEvent('MouseEvents');
      clickEvent.initEvent('dblclick', true, true);
      container.dispatchEvent(clickEvent);
    },
    getPresentationModeButtonTooltip(index){
      switch (index) {
        case 1:
          return 'Faces'
        case 2:
          return 'Faces + Edges'
        case 3:
          return 'Edges'
        default:
          return 'Geh heim'
      }
    },
    processDetailsTabCheckBoxClick(payload){

      if (payload.key === 'show_taktarea_linked_edges') {
        if(payload.value) {
          // show
          this.setGroupIndicesByIds({name: 'taktarea_elements', ids: this.getAllChildObjectIds({parent: this.active_tree_element_process, tree_type: 'process', targets: ['ta_elements']}).ta_elements});
        } else {
          // hide
          this.setGroupIndicesByIds({name: 'taktarea_elements', ids: []});
        }
      }

      if (payload.key === 'show_steps_linked_edges') {
        if(payload.value) {
          // show
          this.setGroupIndicesByIds({name: 'step_elements', ids: this.getAllChildObjectIds({parent: this.active_tree_element_process, tree_type: 'process', targets: ['elements']}).elements});
        } else {
          // hide
          this.setGroupIndicesByIds({name: 'step_elements', ids: []});
        }
      }

      if (payload.key === 'show_taktareashapes') {
          // let ids = Object.keys(this.$store.state.Ultra.taktareashapes);
          // let val = this.visible_taktareashapes.taktareashapes;
          // for (let i = 0; i < ids.length; i++) {
          //   let id = ids[i];
          //   let mesh = this.scene.getObjectByName(`shape_unstaged_${id}`);
          //   console.log(mesh);
          //   if (mesh) {
          //     if (payload.value && (val.includes(id) || val.includes(parseInt(id)))) {
          //       mesh.visible = true;
          //     } else {
          //       mesh.visible = false;
          //     }
          //   }  
          // }
          this.taktareashapes_group.visible = payload.value;
      }

      this.updateProjectStructureValue(payload);
    },
    isObjectFullFetched(object) {
      if (!object.full_fetched && (object.type === 'elements' || object.type.includes('steps'))) {
        return false;
      } else {
        return true;
      }
    },
    getLinkedStepDetail(element_id) {
      if (this.$store.state.Ultra.tworksteps[element_id]) {
        return this.$store.state.Ultra.tworksteps[element_id];
      }
      else {
        return this.$store.state.ProjectStructure.project_steps.tworksteps[element_id];
      }
    },
    handleClickHeader(tree_type, evt) {
      let value;
      // // test: sync projectstructure - taktplan
      // let parent_value;
      if (this[`active_tree_element_${tree_type}_id_string`] === `${evt.type}#${evt.id}`) { //object already active
        value = false;
        // // test: sync projectstructure - taktplan
        // parent_value = false;
      } else {
        value = evt;
        // // test: sync projectstructure - taktplan
        // if (evt.type !== 'object_wrapper') {
        //   parent_value = {
        //     object: evt,
        //     url: this.getObjectUrl(evt),
        //   }
        // }
      }
      this[`active_tree_element_${tree_type}`] = value;

      // // test: sync projectstructure - taktplan
      // if (opener) {
      //   opener.CallParent(parent_value);
      // }

    },
    set4DSimulation(takt){
      if (takt < 0) {
        takt = 0;
      }
      this.current_4d_takt = takt;
      this.showElementsByTakt({project_id: this.project_id, takt_index: this.current_4d_takt, cumulative: this.cumulative_4d});
    },
    testreact() {
      this.updateUDObject({
        url: [{ elements: this.active_tree_element_spatial.id }],
        update: { height: 100 }
      })
    },
    getTabs(tree_type, object) {
      if (!object) {
        return [{ title: 'Attributes', content: 'details' }];
      }
      else if (tree_type === 'spatial') {
        if (object.type === 'elements') {
          return [{ title: 'Attributes', content: 'details' }, { title: 'Properties', content: 'props' }, { title: 'AREAS', content: 'taktareas' }, { title: 'Steps', content: 'steps' }];
        } else if (object.type === 'object_wrapper') {
          return [{ title: 'AREAS', content: 'taktareas' }, { title: 'Steps', content: 'steps' }];
        } else {
          return [{ title: 'Attributes', content: 'details' }, { title: 'Properties', content: 'props' }, { title: 'AREAS', content: 'taktareas' }, { title: 'Steps', content: 'steps' }];
        }
      } else {
        if (object.type.includes('steps')) {
          return [{ title: 'Attributes', content: 'details' }, { title: 'Step ELs', content: 'elements' }];
        } else if (['twaggons', 'tworkpackages'].includes(object.type)) {
          return [{ title: 'Attributes', content: 'details' }, { title: 'Step ELs', content: 'elements' }];
        } else if (object.type === 'taktareas') {
          return [{ title: 'Attributes', content: 'details' }, { title: 'Area ELs', content: 'ta_elements' }, { title: 'Step ELs', content: 'elements' }, { title: 'Shapes', content: 'shapes' }]
        } else {
          return [{ title: 'Attributes', content: 'details' }, { title: 'Area ELs', content: 'ta_elements' }, { title: 'Step ELs', content: 'elements' }, { title: 'Shapes', content: 'shapes' }]
        }
      }
    },
    btnTitle(index) {
      this.active_struct_mode = this.struct_modes[index];
    },
    // createTree(tree_type) {
    //   let start = new Date();
    //   let project = { id: this.project_id, type: 'projects', children: [], parent_path: [], parents_by_type: {}, name: this.project.name, open: false, all_elements: [] }
    //   this.addRecursiveWrapper(project, tree_type);
    //   let duration = new Date().getTime() - start.getTime();
    //   console.log(duration);
    //   console.log(project);
    //   this[`tree_${tree_type}`].children.splice(0, 1, project)
    // },
    // addRecursiveWrapper(parent, tree_type) {
    //   let parent_object = store.state.Ultra[parent.type][parent.id];
    //   let children = [];
    //   let unhandled_children = [];
    //   let parent_path = JSON.parse(JSON.stringify(parent.parent_path));
    //   parent_path.push({ type: parent.type, id: parent.id, name: parent.name });
    //   let parents_by_type = JSON.parse(JSON.stringify(parent.parents_by_type));
    //   if (!parents_by_type[parent.type]) {
    //     parents_by_type[parent.type] = [];
    //   }
    //   parents_by_type[parent.type].push(parent.id);
    //   // check for children
    //   this[`tree_objects_${tree_type}`].forEach(type => {
    //     if (parent_object[type]) {
    //       for (let i = 0; i < parent_object[type].length; i++) {
    //         let id = parent_object[type][i];
    //         let el;
    //         // edge cases elements
    //         if (type === 'elements') {
    //           if (this.$store.state.Ultra.elements[id]) {
    //             el = this.$store.state.Ultra.elements[id];
    //           } else {
    //             el = this.$store.state.ProjectStructure.project_elements[id];
    //           }
    //           // twaggons
    //         }
    //         else if (type === 'twaggons') {
    //           el = this.$store.state.Ultra.twaggons[id];
    //           if (el.token) {
    //             el.name = el.token;
    //           } else {
    //             el.name = `waggon ${id}`
    //           }
    //         }
    //         else if (type.includes('steps')) {
    //           if (this.$store.state.Ultra[type][id]) {
    //             el = this.$store.state.Ultra[type][id];
    //             el.name = el.text;
    //           }
    //           else {
    //             el = this.$store.state.ProjectStructure.project_steps[type][id];
    //             el.name = el.text;
    //           }
    //         }
    //         else {
    //           el = this.$store.state.Ultra[type][id];
    //         }
    //         let child = { id: id, type: type, children: [], open: false, all_elements: [], parent_path: parent_path, parents_by_type: parents_by_type };
    //         Object.assign(child, el);
    //         if (type === 'elements') {
    //           child.all_elements = [id];
    //         } else if (tree_type === 'spatial') {
    //           // child.all_elements = this.$store.state.Ultra[type][id].all_elements;
    //           child.all_elements = this.getAllChildElements({parent_type: child.type, parent_id: child.id});
    //         }
    //         children[children.length] = child;
    //         if ((this[`show_tree_objects_${tree_type}`][type]) && this[`show_tree_objects_${tree_type}`][parent.type]) {
    //           parent.children[parent.children.length] = child;
    //         } else if (this[`show_tree_objects_${tree_type}`][type]) {
    //           unhandled_children[unhandled_children.length] = child;
    //         }
    //       }
    //     }
    //   });
    //   // next recursive iteration
    //   for (let i = 0; i < children.length; i++) {
    //     let child = children[i];
    //     if (child.type !== 'elements' && !child.type.includes('steps')) {
    //       let parent2 = child;
    //       let unhandled_children2 = this.addRecursiveWrapper(parent2, tree_type);
    //       for (let j = 0; j < unhandled_children2.length; j++) {
    //         let el = unhandled_children2[j];
    //         unhandled_children[unhandled_children.length] = el;
    //       }
    //     }
    //   }
    //   // save unhandled children
    //   if (this[`show_tree_objects_${tree_type}`][parent.type]) {
    //     for (let i = 0; i < unhandled_children.length; i++) {
    //       let el = unhandled_children[i];
    //       parent.children[parent.children.length] = el;

    //     }
    //     // sort and group elements or steps
    //     return [];
    //   } else {
    //     return unhandled_children;
    //   }
    // },
    triggerFilterCall(tree_type) {
      // build payload, no incomplete lines!
      let isLineComplete = function(object) { //same logic as filter line component
        if (object.type === 'filter_attr') {
                if (object.value && object.active) {
                    return true;
                } else {
                    return false;
                }
            } else if (object.type === 'filter_prop') {
                if(object.propsetname && object.propname && object.value && object.active) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true
            }
      };
      let buildFilterPayload = function(payload) {
          for (let i = 0; i < payload.length; i++) {
          let object = payload[i];
          // go through nested array
          if (Array.isArray(object)) {
            buildFilterPayload(object);
            if (object.length === 1) { //remove array around object
              payload.splice(i, 1, object[0]);
            } else if (object.length === 0) {
              let count;
              let index;
              if (i === payload.length-1) {
                if (payload.length > 1) {
                  count = 2;
                  index = i-1;
                } else {
                  count = 1;
                  index = i;
                }
              } else {
                count = 2;
                index = i;
              }
              payload.splice(index, count); // remove empty array
            }
          } else if (object.type !== 'operator') { //is line
            let complete = isLineComplete(object);
            if (!complete) { // delete line and following operator 
              let count;
              let index;
              if (i === payload.length-1) {
                if (payload.length > 1) {
                  count = 2;
                  index = i-1;
                } else {
                  count = 1;
                  index = i;
                }
              } else {
                count = 2;
                index = i;
              }
              payload.splice(index, count);
              i--;
            }
          }
        }
        
      }
      let filter_payload = JSON.parse(JSON.stringify(this[`filter_object_${tree_type}`]));
      buildFilterPayload(filter_payload, false, false);

      if(tree_type === 'spatial') {
        if (filter_payload.length === 0) {
          this.toggleFilter({value: false, type: 'spatial'});
          this.setCollectionObjects({ 
            action: 'set', 
            ids_by_target: {elements: Object.keys(this.$store.state.Ultra.elements)}, 
            collection_name: 'visible_elements' 
          });
        }

        this.requestProjectElementsFiltered({ project_id: this.project_id, filter: filter_payload }).then(filtered_elements => {
          // console.log('SET VISIBILE')
          if (this.$store.state.ProjectStructure.filter.spatial.active) {
            this.setCollectionObjects({ 
                action: 'set', 
                ids_by_target: {elements: filtered_elements}, 
                collection_name: 'visible_elements' 
              });
          }
        });
      } else {
        this.requestProjectStepsFiltered({ project_id: this.project_id, filter: filter_payload });
      }


      // handle empty filter? all or none id?
    },
    applyFilter(filter_payload){

      this[`filter_object_${this.filter_management.type}`] = filter_payload;

      if(this.filter_management.type === 'spatial') {
        this.toggleFilter({value: true, type: 'spatial'});
        if (filter_payload.length === 0) {
          this.toggleFilter({value: false, type: 'spatial'});
          this.setCollectionObjects({ 
            action: 'set', 
            ids_by_target: {elements: Object.keys(this.$store.state.Ultra.elements)}, 
            collection_name: 'visible_elements' 
          });
        }

        this.requestProjectElementsFiltered({ project_id: this.project_id, filter: filter_payload }).then(filtered_elements => {
          // console.log('SET VISIBILE')
          if (this.$store.state.ProjectStructure.filter.spatial.active) {
            this.setCollectionObjects({ 
                action: 'set', 
                ids_by_target: {elements: filtered_elements}, 
                collection_name: 'visible_elements' 
              });
          }
        });
      } else {
        this.toggleFilter({value: true, type: 'process'});
        this.requestProjectStepsFiltered({ project_id: this.project_id, filter: filter_payload });
      }

      // this.setValue({ key: 'show_ifc_filter_dialog', value: false });

    },
    is_presentation_mode_buttons(side_button){
      return this.side_buttons[2].clicked && side_button.type === 'presentation-mode'
    },
    showSingleElementOrWrapper(object){
      // console.log('showSingleElementOrWrapper');
      // console.log(object);
      if (object.type === 'elements') {
        this.setCollectionObjects({ action: 'set', ids_by_target: {elements: [object.id]}, collection_name: 'visible_elements' });
        } else {
        this.setCollectionObjects({ action: 'set', ids_by_target: {elements: object.all_elements}, collection_name: 'visible_elements' });
      }
    },
    setCollection(collection_name, object) {
        const result = this.checkSelectedResult(collection_name, object);

        let el_ids;
        if (object.type === 'elements') {
          el_ids = [object.id];
        } else {
          el_ids = object.all_elements;
        }
        this.setCollectionObjects({
            action: result === 'complete' ? 'remove' : 'add',
            ids_by_target: {elements: el_ids},
            collection_name: collection_name, // visible, selected
        })
    },
    checkSelectedResult(collection_name, object){
      return this.isSet1inSet2({
                set1: {type: 'object', value: object, tree_type: 'spatial'},
                set2: {type: 'collection_name', value: collection_name},
                targets: ['elements'],
            }).result;
    },
    gizmoChangeDirection(direction) {
      let distance = Math.sqrt(
        this.camera.position.x*this.camera.position.x
        +
        this.camera.position.y*this.camera.position.y
        +
        this.camera.position.z*this.camera.position.z
        );
      let position = {x: 0, y: 0, z: 0};
      // let rotation = {x: 0, y: 0, z: 0};
      if (direction === 'top') {
        position.z = distance;
        // rotation.z = 1;
      } 
      else if (direction === 'left') {
        position.x = -distance;
        // rotation.x = 1;
      }
      else if (direction === 'right') {
        position.x = distance;
        // rotation.x = -1;
      }
      else if (direction === 'front') {
        position.y = -distance;
        // rotation.y = 1;
      }
      else if (direction === 'back') {
        position.y = distance;
        // rotation.y = -1;
      } else {
        // isometric view
        // distance in x, y and z in iscometric view (45 degrees all)
        let distance_x_y_z = distance / Math.sqrt(3);

        if (direction === 'back-left') {
          position.x = -distance_x_y_z;
          position.y = distance_x_y_z;
          position.z = distance_x_y_z;
        // rotation.z = 1;
        } 
        else if (direction === 'back-right') {
          position.x = distance_x_y_z;
          position.y = distance_x_y_z;
          position.z = distance_x_y_z;
          // rotation.x = 1;
        }
        else if (direction === 'front-left') {
          position.x = -distance_x_y_z;
          position.y = -distance_x_y_z;
          position.z = distance_x_y_z;
          // rotation.x = -1;
        }
        else if (direction === 'front-right') {
          position.x = distance_x_y_z;
          position.y = -distance_x_y_z;
          position.z = distance_x_y_z;
          // rotation.y = 1;
        }
      }
      this.controls.position0.set(position.x,position.y,position.z);
      // this.camera.rotation.set(rotation.x,rotation.y,rotation.z);
      this.controls.target.set(0,0,0);
      this.controls.reset();
    },
    gizmoChangeCamera(camera_type) {
      this.changeCamera(camera_type);
    },
    updateTaktareashapeMesh(payload) {
      // get geom
      let geom;
      let mesh;
      if (this.edit_geometry_object.type === 'taktareashapes' && this.edit_geometry_object.id === payload.shape.id) {
        geom = this.edit_geom;
        mesh = this.edit_geom_mesh;
        // handle values, only saved in store object
        if (payload.type === 'offset') {
          geom.offset[1] = payload.value - geom.offset[1];
        } else if (payload.type === 'extrude_value') {
          geom.extrude_value = payload.value;
        }
      } else {
        let shape_mesh = this.scene.getObjectByName(`shape_unstaged_${payload.shape.id}`);
        if (shape_mesh) {
          geom = payload.shape.geometry;
          mesh = shape_mesh;
        } else {
          geom = false;
          mesh = false;
        }
      }
      if (geom) { //if has geometry
        // set values
        if (payload.type === 'offset') {
            // mesh.geometry.translate(geom.offset[0], (-1*(payload.value - geom.offset[1])), geom.offset[2]);
            mesh.position.y = parseFloat(payload.value);
          } else if (payload.type === 'extrude_value') {
            // exception if edit mode
            mesh.geometry.dispose();
            mesh.geometry = this.createUnstagedGeometry(geom);
          }
      }
    },
    getAllShapesElements(){
      for (let i = 0; i < this.taktareashapes.length; i++) {
        const shape = this.taktareashapes[i];
        this.getShapesElements(shape);
      }
    },
    getShapesElements(shape) {

      let ids = this.getGeometrySelection(this.visible_normal_group.children, shape, true, false); 
      this.setCollectionObjects({collection_name: 'selected_elements', action: 'add', ids_by_target: {elements: ids}})

    },
    togglePresentationMode() {
      this.handleSideButtons('presentation-mode');
    },
    resetNewSpatialObject(){
      this.new_spatial_object = {
        type: 'elements',
        name: '',
        ifc_type: 'IFCBUILDINGELEMENTPROXY',
        description: '',
        count: 1,
        height: 0,
        width: 0,
        length: 0,
        volume: 0,
        floor_area: 0,
        side_area: 0,
        perimeter: 0,
        surface: 0,
        lateral_surface: 0,
        weight: 0,
      };
    },

    /**
     * 
     * @param {Object} filterConfig - Object containing all input parameters
     *   - tree_type: 'Spatial' or 'Process' Tree
     *   - filtertype: Filtertype e.g. 'filter_attr' or 'filter_prop'
     *   - attributename: Filter Atributename e.g. 'ifc_type'
     *   - propsetname: Filter Property Set Name
     *   - propname: Filter Property Name
     *   - value: Filter Value e.g. 'IfcWall'
     *   - event: '@click event'
     */
    takeoverFilter(filterConfig){
      const { tree_type, filtertype, attributename, propsetname, propname, value, event } = filterConfig;
      if (event.ctrlKey) {
        // Add new Filterline
        // console.log('Filter mit Strg-Taste registriert');
        if (tree_type === 'process') {
          if (this.filter_object_process.length !== 0) {
            // add Operator Line, "Or"-Operator for Process Case
            this.filter_object_process.splice(this.filter_object_process.length, 0, { type: 'operator', operator: "||" });
          }
          this.filter_object_process.splice(this.filter_object_process.length, 0, { type: filtertype, attributename: attributename, operator: '===', value: value, active: true });

        }
        else if (tree_type === 'spatial') {
          if (this.filter_object_spatial.length !== 0) {
            // add Operator Line
            this.filter_object_spatial.splice(this.filter_object_spatial.length, 0, { type: 'operator', operator: "&&" });
          }
          if (filtertype === 'filter_attr') {
            this.filter_object_spatial.splice(this.filter_object_spatial.length, 0, { type: filtertype, attributename: attributename, operator: '===', value: value, active: true });
          }
          else if(filtertype === 'filter_prop') {
            this.filter_object_spatial.splice(this.filter_object_spatial.length, 0, { type: filtertype, propsetname: propsetname, propname: propname, operator: '===', value: value, active: true });
          }
        }
      }
      else {
        // Set Filter
        if (tree_type === 'process') {
          this.filter_object_process = [{ type: filtertype, attributename: attributename, operator: '===', value: value, active: true  }];
        }
        else if (tree_type === 'spatial') {
          if (filtertype === 'filter_attr') {
            this.filter_object_spatial = [{ type: filtertype, attributename: attributename, operator: '===', value: value, active: true  }];
            // wait for the change
            this.$nextTick(() => {
              this.filter_object_spatial[0].value = value;
              this.filter_object_spatial[0].active = true;
            });
          }
          else if (filtertype === 'filter_prop') {
            this.filter_object_spatial = [{ type: filtertype, propsetname: propsetname, propname: propname, operator: '===', value: value, active: true  }];
          }
        }
      }
      this.triggerFilterCall(tree_type);
    },
    
    createIFCObject(){
      let url = [
        {[this.project_structure_create_dialog.object.type]: this.project_structure_create_dialog.object.id},
        {[this.new_spatial_object.type]: ''},
        {showWithEntitiesNormalized: ''}
      ];
      if(this.new_spatial_object.count > 1) {
        url = [
          {[this.project_structure_create_dialog.object.type]: this.project_structure_create_dialog.object.id},
          {[this.new_spatial_object.type]: 'createbulk'},
          {showWithEntitiesNormalized: ''}
        ];
      } 
      this.createUObject({
        url: url,
        url_prefix: `/projects/${this.project_id}/projectstructure`,
        u_object: JSON.parse(JSON.stringify(Object.assign(this.new_spatial_object, {order_index: 5, parent: {type: this.project_structure_create_dialog.object.type, id: this.project_structure_create_dialog.object.id}})))
        }).then(() => {
          this.setValue({ key: 'project_structure_create_dialog', value: { show: false, object: {} } }); 
          this.resetNewSpatialObject();
      });
    },

    // multiWindow with LocalStorage
    /**
     * Transfers the information on the active element from the localstorage to the vue data of this view
     * @param {*} event Change Event from Event Listener
     */
    handleStorageChange(event) {
      if (event.key === 'multiWindow') {
        // console.log('handleStorageChange bei multiWindow erkannt');
        // console.log(event);
        try {
          // Versucht, den neuen Wert zu parsen und zuweisen
          let parsedValue = JSON.parse(event.newValue);
          if (parsedValue !== null) {
            this.vueMultiWindowProjectstructure = parsedValue;
            // console.log('this.vueMultiWindowProjectstructure überschrieben aus LocalStorageWert');
          }
        } catch (error) {
          // Fehlerbehandlung, falls das Parsen fehlschlägt
          console.error('Error parsing new value from LocalStorage:', error);
        }
      }
    },

    // ToDo: auslagern in Mixin?
    /**
     * processes the active element in different ways depending on the type in order to obtain the best possible representation in the projectstructure
     */
    takeoverActiveElementToProjectstructure() {
      const { type, id } = this.vueMultiWindowProjectstructure.active_element;
      switch (type) {
        case 'tworkpackages':
        case 'tworksteps':
        case 'twaggon':
        case 'taktareas':
          this.handleActiveProcessElement(type, id);
          break;
        case 'element':
          this.setUiMode('view');
          this.active_tree_element_spatial = { type: 'elements', id };
          this.showSingleElementOrWrapper(this.active_tree_element_spatial);
          break;
        // case 'TaktPlanWorkPackageElements':
        //   this.setUiMode('view');
        //   this.handleActiveProcessElement(type, id);
        //   break;
        case 'takt':
          this.setUiMode('4d');
          this.set4DSimulation(parseInt(id));
          this.active_tree_element_process = false;
          break;
        default:
          this.setUiMode('view');  
          console.log('case not handled in takeoverActiveElementToProjectstructure()');
      }
      // Show invisible Elements
      this.show_invisible = true;
      this.side_buttons[1].icon = 'visibility-on';
      this.side_buttons[1].clicked = true;

      // Wait for the change & zoom to Elements
      if (type != 'takt') {
        this.$nextTick(() => {
          this.zoomToVisible(this.camera);
        });
      }
    },

    /**
     * Helperfunction for takeoverActiveElementToProjectstructure()
     * @param {*} elementType - Type of the active Element
     * @param {*} elementId - ID of the active Element
     */
    handleActiveProcessElement(elementType, elementId) {
      let parentObject, result;
      this.active_tree_element_process = { type: elementType, id: elementId };
      this.setUiMode('view');
      // Get the contained elements
      this.showSingleElementOrWrapper(this.active_tree_element_process);
      parentObject = this.$store.state.Ultra[elementType][elementId];
      // console.log(parentObject);
      result = this.getAllChildObjectIds({ parent: parentObject, tree_type: 'process', targets: ['elements'] });
      // console.log(result);
      this.setCollectionObjects({ action: 'set', ids_by_target: result, collection_name: 'visible_elements' });
      this.active_tree_element_spatial = false; // Unselect active spatial (geometry) Element
    },
  },

  beforeDestroy() {
    // Test multiWindow LocalStorage
    // window.removeEventListener('beforeunload', this.removeWindowFromLocalStorage());
    window.removeEventListener('storage', this.handleStorageChange);
    // _____________________________________________________________________
  },
}
</script>

<style scoped>
.project-structure-frame-background {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: radial-gradient(circle, #BDBDBD 0%, #757575 50%, #616161 80%, #424242 100%);
}



.test {
  background-color: green;
  border-radius: 8px;
  width: 100%;
  height: 100%;
}

/* Für Detail annsicht */
.tree_details {
  padding: 10px;
  word-wrap: normal;
  overflow: hidden;
}

.process_details_path {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 10px 0;
  background-color: #E0E0E0;

}

.process_details_path_item {
  width: calc(100%/ 5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.process_details_path_item:hover {
  background-color: #E0E0E0;
}

.detail_list_view {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-count: 2;
  column-gap: 10px;
  row-gap: 6px;
  /* grid-template-columns: repeat(auto-fit, 186px); */
}

.detail_list_view_items {
  display: grid;
  /* grid-template-columns: 1fr 1fr; */
  column-count: 2;
  column-gap: 10px;
  white-space: nowrap;
}

.details_list_view_labels {
  justify-content: flex-end;
  /* float: right;
  text-align: right; */
}

.grid_space {
  height: 20px;
}

.detail-btn {
  display: block;
  padding: 5px 10px 10px 10px;
  height: auto;
  float: right;
  /* overflow: hidden; */
  bottom: 0px;
  width: 100%;
  z-index: 50;

}

.detail_list_btn {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
}

.detail_list_btn_right {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
}

.linked_list {
  display: flex;
  flex-direction: column;
  padding: 0 5px;

}

.linked_line {
  height: 1px;
  width: 100%;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 50%, rgba(252, 252, 254, 0) 100%);
}

.linked_list_element {}

/* Detailansicht Ende */


.pointer_all {
  pointer-events: auto;
  /* Fix: Canvas Interaction */
}
.side-button {
  background-color: #424242;
}

.tree-header-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1 0px;
  grid-gap: 5px;
}
.gizmo-container {
  display: flex;
  position: absolute;
  right: 0px;
  top: 0px;
  flex-direction: column;
  justify-content: center;
  /* zoom: 0.6; */
  pointer-events: all;
  transition: all ease-in-out 0.2s;
}
/* .gizmo-container:hover {
  zoom: 1;
} */
.gizmo-btn-direction {
  display: flex;
  width: 28px;
  height: 28px;
  margin: 2px;
  justify-content: center;
  align-items: center;
  background-color: rgba(200,200,200,0.5);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 300;
  cursor: pointer;
  pointer-events: all;
}
.gizmo-btn-camera {
  display: flex;
  width: 50px;
  height: 20px;
  margin: 2px;
  justify-content: center;
  align-items: center;
  background-color: rgba(150,150,150,0.5);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 300;
  cursor: pointer;
  pointer-events: all;
}
.isometric {
  background-color: rgba(150,150,150,0.2);
}
.drawing-toolbar {
  position: absolute;
  width: 600px;
  height: 60px;
  bottom: 0px; 
  left: 50%;
  transform: translateX(-50%);
}
.selection-toolbar {
  position: absolute;
  /* width: 400px; */
  height: 50px;
  bottom: 0px; 
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
}

.source-and-takeover-filter-field {
  display: flex; 
  align-items: center; 
  grid-gap: 2px;
  padding-top: 2px;
  margin-bottom: 8px;
}
</style>
  